<template>
  <div id="constructionManagement">
    <!-- <div class="topcover" :style="'margin-left:' + (-pageRight) + 'px'"></div>
    <div class="bottomcover" :style="'margin-left:' + (-pageRight) + 'px'"></div>
    <div class="leftcover" :style="'width:' + pageRight + 'px;margin-left:' + (-pageRight) + 'px'"></div>
    <div style="height:58px;z-index:1;position: relative;">
      <div class="mainHead">
        <div class="route">
          <span class="crumbs"></span><span class="link" @click="goback">建筑管理</span><span class="arrow" v-show="!btnShow">></span><span v-show="!btnShow">标注平面图</span>
        </div>
        <div> 
          <el-button type="primary" v-show="btnShow" @click="floorManagement">{{returnTxt}}</el-button>
          <el-button type="primary" v-show="!btnShow" @click="goback">返回</el-button>
        </div>
      </div>
    </div>
    <div class="page" :style="'margin-right:' + pageRight + 'px'">
      <div class="rightcover" :style="'width:' + pageRight + 'px;margin-right:' + (-pageRight) + 'px'"></div>
      <div class="image-move-wapper" @click="!btnShow ? showSetting() : ''">
        <div class="svg_header" style="width:100%" @click="settingEvent($event)">
          <div class="svg_header_title"> {{Name}}</div>
          <div class="svg_header_slider">
            <div class="percent minus">
              <i @click="!deleteDisabled ? subtract() : ''" :class="deleteDisabled ? 'el-icon_disabled el-icon-minus' : 'el-icon-minus'"></i>
            </div>
            <div class="percent" style="margin-left: 25px;">
              <el-slider :disabled="deleteDisabled" v-model="value2" :show-tooltip="false" :format-tooltip="formatTooltip" :min="10" :max="maxValue" @change="slider(value2)"></el-slider>
            </div>
            <div class="percent plus">
              <i @click="!deleteDisabled ? add() : ''" :class="deleteDisabled ? 'el-icon_disabled el-icon-plus' : 'el-icon-plus'"></i>
            </div>
            <div class="percent price" :class="deleteDisabled ? 'el-icon_disabled' : ''">{{value3}}</div>
          </div>
          <div class="svg_header_btn">
            <el-upload
              class="upload-demo"
              ref="fileUpload"
              :action="uploadUrl"
              :show-file-list="false"
              :file-list="fileList"
              :on-progress='getProgress'
              :on-change="uploadChange"
              :on-success='successUpload'
              :auto-upload='false'
              >
              <el-button v-show="!btnShow" class="svg_header_right_btn" v-if="isAuth('basicData:insertUploadPhoto')">上传</el-button>
            </el-upload>
            <el-button v-show="!btnShow" :disabled="deleteDisabled" class="svg_header_right_btn" @click="deleteRightPointData" v-if="isAuth('basicData:delLocationByBuildIdOrFloorId')">删除</el-button>
          </div>
        </div>
        <div v-show="rightList" class="floor_list" @click="settingEvent($event)">
          <el-button class="font-icon btn1" :disabled="btnDisable1" :class="btnDisable1 ? 'floor_list_btn1' :'floor_list_btn'"  icon="el-icon-arrow-up" @click="upFloor"></el-button>
          <div class="showList" style="overflow:hidden;max-height:200px;" :style="rightList ? 'height:' + floorListLength * 40 + 'px;' : '' ">
            <ul ref="floorListUl" @wheel.prevent="wheelList(event)" class="floor_list_ul" style="scrollbar-width: none;" :style="rightList ? 'height:' + floorListLength * 40 + 'px;' : '' ">
              <li v-for="(item,index) in floorList" :key="index" :class="item.active ? 'active' : ''" @click="floorActive(item.id,item.floorIndex,index)">{{item.floorIndexs > 0 ? 'L' + item.floorIndexs : 'B' + Math.abs(item.floorIndexs)}}</li>
            </ul>
          </div>
          <el-button class="bor_top font-icon btn2" :disabled="btnDisable2" :class="btnDisable2 ? 'floor_list_btn1' :'floor_list_btn'" icon="el-icon-arrow-down" @click="downFloor"></el-button>
        </div>
        <div :style="'width:'+ boxwidth + 'px;'">
          <div id="svg1" @mousedown="DragContainerMouseDown" :style="'margin-left:' + dragContainer.newPoint.left+'px; margin-top:' + dragContainer.newPoint.top+'px'">
            <img @click="settingEvent($event)" draggable="true" :src="imgUrl" :style="'width:' + imgWidth + 'px;height:' + imgHeight + 'px;margin-top:' + marginTop + 'px;margin-left:' + marginLeft + 'px;'" class="bgImg" @mousedown="down(event)"
                @mouseup="!btnShow ? up(event) : up1(event)"
                @mousemove="move(event)" v-show="!deleteDisabled" id="svgImage" @mousewheel="wheel(event)">
          </div>
          <div v-if="customerType">
            <img @click="settingEvent($event)" 
               v-show="!items.big" 
               :src="items.color" 
               @mouseover="hover(items.id)"
               @mouseout="out(items.id)" 
               @mouseup="!btnShow ? deletePoint(items.id) : up1(event)" 
               style="width:34px;height:34px;position: absolute;" 
               v-for="(items, index4) in point" 
               :key="'4-' + index4" 
               :style="'margin-top:' + dragContainer.newPoint.top + 'px;margin-left:' + dragContainer.newPoint.left + 'px;left:' + ((items.remark == '0' ? items.latitude : items.latitude) * imgWidth - 17) + 'px;top:' + ((items.remark == '0' ? items.longitude : items.longitude) * imgHeight - 32) + 'px;'" class="pointImg">
            <img @click="settingEvent($event)" 
               v-show="items.big" 
               :src="items.color" 
               @mouseover="hover(items.id)"
               @mouseout="out(items.id)" 
               @mouseup="!btnShow ? deletePoint(items.id) : up1(event)" 
               style="width:40px;height:40px;position: absolute;" 
               v-for="(items, index4) in point" :key="'5-' + index4" :style="'margin-top:' + dragContainer.newPoint.top + 'px;margin-left:' + dragContainer.newPoint.left + 'px;left:' + ((items.remark == '0' ? items.latitude : items.latitude) * imgWidth - 20) + 'px;top:' + ((items.remark == '0' ? items.longitude : items.longitude) * imgHeight - 37) + 'px;'" class="pointImg">        
          </div>
          <div v-else>
            <div v-show="!items.big"  style="width:160px;position: absolute;text-align: center;font-size:13px;color:#e5e5e5;text-shadow:#198cff 1px 0 0,#198cff 0 1px 0,#198cff -1px 0 0,#198cff 0 -1px 0;" 
               v-for="(items, index4) in point" 
               :key="'41-' + index4" 
               :style="'margin-top:' + dragContainer.newPoint.top + 'px;margin-left:' + dragContainer.newPoint.left + 'px;left:' + ((items.remark == '0' ? items.latitude : items.latitude) * imgWidth - 80) + 'px;top:' + ((items.remark == '0' ? items.longitude : items.longitude) * imgHeight - 53) + 'px;'" class="pointImg">{{items.buildingName}}</div>
            <div v-show="items.big"  style="width:160px;position: absolute;text-align: center;font-size:18px;color:#e5e5e5;text-shadow:#198cff 1px 0 0,#198cff 0 1px 0,#198cff -1px 0 0,#198cff 0 -1px 0;" 
               v-for="(items, index4) in point" 
               :key="'412-' + index4" 
               :style="'margin-top:' + dragContainer.newPoint.top + 'px;margin-left:' + dragContainer.newPoint.left + 'px;left:' + ((items.remark == '0' ? items.latitude : items.latitude) * imgWidth - 80) + 'px;top:' + ((items.remark == '0' ? items.longitude : items.longitude) * imgHeight - 58) + 'px;'" class="pointImg">{{items.buildingName}}</div>
            <img @click="settingEvent($event)" 
               :src="items.color" 
               @mouseup="!btnShow ? deletePoint(items.id) : up1(event)" 
               style="width:34px;height:34px;position: absolute;" 
               v-for="(items, index4) in point" 
               :key="'4-' + index4" 
               :style="'margin-top:' + dragContainer.newPoint.top + 'px;margin-left:' + dragContainer.newPoint.left + 'px;left:' + ((items.remark == '0' ? items.latitude : items.latitude) * imgWidth - 17) + 'px;top:' + ((items.remark == '0' ? items.longitude : items.longitude) * imgHeight - 32) + 'px;'" class="pointImg">       
          </div>
        </div>
        <div @click="settingEvent($event)" 
           v-show="items.povperShow" 
           @mouseover="hoverDetail(items.id)" 
           @mouseout="outDetail(items.id)"  
           v-for="(items, index3) in point"
           :key="'3-' + index3"
          class="detail"
          :style="items.showDetailPath"
        >
          <div class="boxItem" :class="{disabled:items.enabled}">
            <div class="boxIcon">
              <img v-if="items.type == 1" src="../../assets/img/typeIcon1.png" alt="icon">
              <img v-else-if="items.type == 2" src="../../assets/img/typeIcon2.png" alt="icon">
              <img v-else-if="items.type == 3" src="../../assets/img/typeIcon3.png" alt="icon">
              <img v-else-if="items.type == 4" src="../../assets/img/typeIcon4.png" alt="icon">
              <img v-else-if="items.type == 5" src="../../assets/img/typeIcon5.png" alt="icon">
              <img v-else-if="items.type == 6" src="../../assets/img/typeIcon6.png" alt="icon">
            </div>
            <div class="boxIconDisable" v-show="items.enabled">
              <img src="../../assets/img/prohibit.png" alt="icon">
            </div>
            <span class="tipsNum" v-show="items.warnNum != 0">
              <span v-if="items.warnNum>99">99+</span>
              <span v-else>{{items.warnNum}}</span>
            </span>
            <div class="boxText">
              <div>
                  <el-tooltip class="item" effect="dark" :content="items.monitoringName" placement="bottom-start">
                      <span>{{items.monitoringName}}</span>
                  </el-tooltip>
              </div>
              <div>
                  <el-tooltip class="item" effect="dark" :content="items.detailAddress" placement="bottom-start" >
                      <span>{{items.detailAddress}}</span>
                  </el-tooltip>
              </div>
              <div>
                <span class="Online" v-if="items.connectStatus == false">在线</span>
                <span class="Offline" v-else>离线</span>
                <span class="Online" v-if="items.deviceStatus == 0">启用</span>
                <span class="fault" v-else>故障</span>
                <span class="Online" v-if="items.runStatus == false">正常</span>
                <span class="alarm" v-else>告警</span>
              </div>
            </div>
          </div>
        </div>
        <div class="No" v-show="deleteDisabled">
            <img src="../../../static/img/NoUploaded.png">
            <span>尚未上传建筑平面图</span>
        </div>
      </div>
    </div>
    <el-dialog
    class="uploadDialog"
      title="上传进度"
      :visible.sync="dialogVisible"
      width="30%"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      >
      <el-progress :percentage="uploadprogress"></el-progress>
      <span class="cancel" @click="cancelUpload">取消</span>
    </el-dialog>
    <el-dialog title="提示" class="tips" :visible.sync="dialogTipsVisible" :modal="false" @open="openDialog">
      <span>{{tip}}</span>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogTipsVisible = false">我知道了</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import {ajaxFuncJson,uploadIp} from '@/api/ajax';
import {mapState,mapGetters,mapActions} from 'vuex';
import editBulitingVue from '../../page/editBuliting/editBuliting.vue';

export default {
  name: "constructionManagement",
  data() {
    return {
      customerType:'', //区分校企和建筑(四期定义)
      dragContainer: {
        box: {
          w: 0,
          h: 0
        },
        point: {
          left: 0,
          top: 0
        },
        newPoint: {
          left: 0,
          top: 0
        }
      },
      mousePoint: {
        x: 0,
        y: 0
      },
      imageShowBox: {
        box: {
          w: 0,
          h: 0
        },
        dragcheck: {
          h: true,
          v: true
        }
      },
      returnTxt:'首页管理',
      boxwidth: '',
      boxheight: window.innerHeight - 137,
      value2: 100, // slide默认值 图片原始大小为100/后期修改
      value3: '',
      isDrag: false, //鼠标点击按下判断false按下
      timmerHandle: null, // 定时器
      circleUp: true, // 判断鼠标是否在圆点中点击，组织事件冒泡
      path: [],
      pointIndex: 1, //自定义的point id
      scale: 100, // 保存缩放大小
      event: null,
      viewBoxPath: '0 0 1560 1143',
      maxValue: 100 * Math.pow(1.1,15),
      svgHeaderWidth: '',
      svgHeaderHeight: window.innerHeight - 137,
      pageRight: '',
      btnShow: JSON.parse(sessionStorage.getItem('btnShow')),
      setPoint: [], // 客户设置点
      floorSetPoint: [], // 楼层设置点
      uploadUrl: uploadIp() + '/file/uploadFile',  // 上传地址
      dialogVisible: false,
      uploadprogress: 0,   // 上传进度
      floorid: '', // 楼层id
      index: null,  // 楼层索引
      btnDisable1: false, // 上一层按钮状态
      btnDisable2: false, // 下一层按钮状态
      imgsrc: './static/img/green.png',   // 默认图片颜色
      Name: sessionStorage.getItem('Name'),  // 客户名
      dialogTipsVisible: false,
      tip: '',
      isConfirm: true,
      valid1: false,
      valid2: false,
      fileList: [],
      validWidth:500,
      validHeight:500,
      deletaState:1,
      imgFile:[],
      hoverShow:false,
      isImgSize:false,
      isBili:false,
      windowResize:null,
      marginTop: 0,
      marginLeft: 0,
      lastPoint: {
        x: 0,
        y: 0
      },
      imgWidth: '',
      imgHeight: '',
      setPointLeft: '', // 初始时左侧导航+padding的和值
      setPointTop: '',   // 初始时图片到窗口顶部的距离
      isSuccessImg:false,    //是否是上传成功的之后的回调
      widthText: '',
      overflowText: '',
    }
  },
  created() {
    this.$emit('getItem', true); //是否显示左侧新增建筑图标
  },
  // mounted() {
  //   document.getElementById('bodyMain').style.overflow = 'hidden';
  //   document.getElementsByClassName('el-main')[0].style.overflow = 'hidden';
  //   if (window.innerWidth >= 1980) {
  //     this.boxwidth = window.innerWidth - 420;
  //     this.svgHeaderWidth = window.innerWidth - 380 - 40;
  //     this.setPointLeft = 400;
  //     this.pageRight = 20;
  //   } else if (window.innerWidth <= 1366) {
  //     this.boxwidth = window.innerWidth - 270 - 0.0105 * window.innerWidth * 2;
  //     this.svgHeaderWidth = window.innerWidth - 270 - 0.0105 * window.innerWidth * 2;
  //     this.pageRight = 0.0105 * window.innerWidth;
  //     this.setPointLeft = 270 + 0.0105 * window.innerWidth;
  //   } else {
  //     this.boxwidth = window.innerWidth - window.innerWidth * 0.198 - 0.0105 * window.innerWidth * 2;
  //     this.svgHeaderWidth = window.innerWidth - window.innerWidth * 0.198 - 0.0105 * window.innerWidth * 2;
  //     this.pageRight = 0.0105 * window.innerWidth;
  //     this.setPointLeft = window.innerWidth * 0.198 + 0.0105 * window.innerWidth;
  //   }
  //   this.viewBoxPath = '0 0 ' + this.boxwidth + ' ' + (window.innerHeight - 137);
  //   let _this=this;
  //   _this.windowResize=()=>{
  //     if (window.innerWidth >= 1980) {
  //       _this.svgHeaderWidth = window.innerWidth - 380 - 40;
  //       _this.pageRight = 20;
  //     } else if (window.innerWidth <= 1366) {
  //       _this.svgHeaderWidth = window.innerWidth - 270 - 0.0105 * window.innerWidth * 2;
  //       _this.pageRight = 0.0105 * window.innerWidth;
  //     } else {
  //       _this.svgHeaderWidth = window.innerWidth - window.innerWidth * 0.198 - 0.0105 * window.innerWidth * 2;
  //       _this.pageRight = 0.0105 * window.innerWidth;
  //     }
  //   };
  //   window.addEventListener('resize',_this.windowResize);
  //   _this.$refs.floorListUl.style.marginTop = sessionStorage.getItem('floorListUlTop')
  //   // 图片宽度高度适应窗口并居中
  //   _this.imgWidth = _this.boxwidth;
  //   _this.imgHeight = _this.$store.state.pointData.high * _this.boxwidth/_this.$store.state.pointData.width;
  //   _this.dragContainer.newPoint = {
  //     left:  0,
  //     top:  _this.svgHeaderHeight - _this.imgHeight < 0 ? 0 : (_this.svgHeaderHeight - _this.imgHeight) / 2
  //   }
  //   _this.value2 = _this.imgWidth/_this.$store.state.pointData.width * 100
  //   _this.setPointTop = 127
  // },
  // updated() {
  //   let _this = this;
  //   _this.btnShow = JSON.parse(sessionStorage.getItem('btnShow'));
  //   _this.Name = sessionStorage.getItem('Name');
  //   // 确保DOM元素已经渲染成功，然后获取拖拽容器和显示区域的大小
  //   if (_this.$store.state.leftoggle) {
  //     if (_this.$store.state.pointData.Info.length > 0) {
  //       _this.$store.state.pointData.Info.map( e => {
  //         _this.showImg1(e)
  //       })
  //     }
  //   } else {
  //     if (_this.$store.state.pointData.Info.length > 0) {
  //       _this.$store.state.pointData.Info.map( e => {
  //         _this.showImg(e)
  //       })
  //     }
  //   }

  //   if (_this.$store.state.pointData.Info.length > 0) { //标记图标渲染
  //     _this.$store.state.pointData.Info.map( e => {
  //       if(this.customerType){ //四期区分建筑图标
  //           if(e.type==1){         //电气
  //             if (e.connectStatus) {    //连接为true   正常
  //               if (sessionStorage.getItem('menuS2') == e.id) {
  //                 e.color = './static/img/electric/electric_grey.png'
  //               } else {
  //                 e.color = './static/img/electric/electric_grey1.gif'
  //               }
  //             } else {
  //               // 在线
  //               if (e.runStatus) {     //故障
  //                 // 正常
  //                 if (e.colorType == 1) {
  //                   if (sessionStorage.getItem('menuS2') == e.id) {
  //                     e.color = './static/img/electric/electric_2.png'   // 黄颜色图片
  //                   } else {
  //                     e.color = './static/img/electric/electric_1.gif'  // 黄颜色动图
  //                   }
  //                 } else if (e.colorType == 2) {
  //                   if (sessionStorage.getItem('menuS2') == e.id) {
  //                     e.color = './static/img/electric/electric_red.png'
  //                   } else {
  //                     e.color = './static/img/electric/electric_red1.gif'
  //                   }
  //                 }
  //               } else {
  //                 if (e.deviceStatus == 1) {
  //                   if (sessionStorage.getItem('menuS2') == e.id) {
  //                     e.color = './static/img/electric/electric_green.png'
  //                   } else {
  //                     e.color = './static/img/electric/electric_green.png'
  //                   }
  //                 } else {
  //                   if (e.lowVoltage) {
  //                     e.color = './static/img/electric/electric_green.png'
  //                   } else {
  //                     if (sessionStorage.getItem('menuS2') == e.id) {
  //                       e.color = './static/img/electric/electric_green.png'
  //                     } else {
  //                       e.color = './static/img/electric/electric_green.png'
  //                     }
  //                   }
  //                 }
  //               }
  //             }
  //           }else if(e.type==2) {  //水压
  //             if (e.connectStatus) {    //连接为true   正常
  //               if (sessionStorage.getItem('menuS2') == e.id) {
  //                 e.color = './static/img/pressure/pressure_grey.png'
  //               } else {
  //                 e.color = './static/img/pressure/pressure_grey1.gif'
  //               }
  //             } else {
  //               // 在线
  //               if (e.runStatus) {     //故障
  //                 if(e.colorType == 1) {
  //                   if (sessionStorage.getItem('menuS2') == e.id) {
  //                     e.color = './static/img/pressure/pressure_2.png'
  //                   } else {
  //                     e.color = './static/img/pressure/pressure_1.gif'
  //                   }
  //                 } else if (e.colorType == 2) {
  //                   if (sessionStorage.getItem('menuS2') == e.id) {
  //                     e.color = './static/img/pressure/pressure_red.png'
  //                   } else {
  //                     e.color = './static/img/pressure/pressure_red1.gif'
  //                   }
  //                 }
  //               } else {
  //                 if (e.deviceStatus == 1) {
  //                   if (sessionStorage.getItem('menuS2') == e.id) {
  //                     e.color = './static/img/pressure/pressure_green.png'
  //                   } else {
  //                     e.color = './static/img/pressure/pressure_green.png'
  //                   }
  //                 } else {
  //                   if (e.lowVoltage) {
  //                     e.color = './static/img/pressure/pressure_green.png'
  //                   } else {
  //                     if (sessionStorage.getItem('menuS2') == e.id) {
  //                       e.color = './static/img/pressure/pressure_green.png'
  //                     } else {
  //                       e.color = './static/img/pressure/pressure_green.png'
  //                     }
  //                   }
  //                 }
  //               }
  //             }
  //           }else if(e.type==3) {  //液位
  //             if (e.connectStatus) {    //连接为true   正常
  //               if (sessionStorage.getItem('menuS2') == e.id) {
  //                       e.color = './static/img/level/level_grey.png'
  //                     } else {
  //                       e.color = './static/img/level/level_grey1.gif'
  //                     }
  //             } else {
  //               // 在线
  //               if (e.runStatus) {     //故障
  //                 if(e.colorType == 1) {
  //                   if (sessionStorage.getItem('menuS2') == e.id) {
  //                     e.color = './static/img/level/level_2.png'
  //                   } else {
  //                     e.color = './static/img/level/level_1.gif'
  //                   }
  //                 } else if (e.colorType == 2) {
  //                   if (sessionStorage.getItem('menuS2') == e.id) {
  //                     e.color = './static/img/level/level_red.png'
  //                   } else {
  //                     e.color = './static/img/level/level_red1.gif'
  //                   }
  //                 }
  //               } else {
  //                 if (e.deviceStatus == 1) {
  //                   if (sessionStorage.getItem('menuS2') == e.id) {
  //                       e.color = './static/img/level/level_green.png'
  //                     } else {
  //                       e.color = './static/img/level/level_green.png'
  //                     }
  //                 } else {
  //                   if (e.lowVoltage) {
  //                     e.color = './static/img/level/level_green.png'
  //                   } else {
  //                     if (sessionStorage.getItem('menuS2') == e.id) {
  //                       e.color = './static/img/level/level_green.png'
  //                     } else {
  //                       e.color = './static/img/level/level_green.png'
  //                     }
  //                   }
  //                 }
  //               }
  //             }
  //           }else if(e.type==4) {  //可燃气
  //             if (e.connectStatus) {    //连接为true   正常
  //               if (sessionStorage.getItem('menuS2') == e.id) {
  //                       e.color = './static/img/gas/gas_grey.png'
  //                     } else {
  //                       e.color = './static/img/gas/gas_grey1.gif'
  //                     }
  //             } else {
  //               // 在线
  //               if (e.runStatus) {     //故障
  //                 if (e.colorType == 1) {
  //                   if (sessionStorage.getItem('menuS2') == e.id) {
  //                     e.color = './static/img/gas/gas_2.png'
  //                   } else {
  //                     e.color = './static/img/gas/gas_1.gif'
  //                   }
  //                 } else if(e.colorType == 2) {
  //                   if (sessionStorage.getItem('menuS2') == e.id) {
  //                     e.color = './static/img/gas/gas_red.png'
  //                   } else {
  //                     e.color = './static/img/gas/gas_red1.gif'
  //                   }
  //                 }
  //               } else {
  //                 if (e.deviceStatus == 1) {
  //                   if (sessionStorage.getItem('menuS2') == e.id) {
  //                       e.color = './static/img/gas/gas_green.png'
  //                     } else {
  //                       e.color = './static/img/gas/gas_green.png'
  //                     }
  //                 } else {
  //                   if (e.lowVoltage) {
  //                     e.color = './static/img/gas/gas_green.png'
  //                   } else {
  //                     if (sessionStorage.getItem('menuS2') == e.id) {
  //                       e.color = './static/img/gas/gas_green.png'
  //                     } else {
  //                       e.color = './static/img/gas/gas_green.png'
  //                     }
  //                   }
  //                 }
  //               }
  //             }
  //           }else if(e.type==5) {  //烟感
  //             if (e.connectStatus) {    //连接为true   正常
  //               if (sessionStorage.getItem('menuS2') == e.id) {
  //                       e.color = './static/img/sensation/sensation_grey.png'
  //                     } else {
  //                       e.color = './static/img/sensation/sensation_grey1.gif'
  //                     }
  //             } else {
  //               // 在线
  //               if (e.runStatus) {     //故障
  //                 if (e.colorType == 1) {
  //                   if (sessionStorage.getItem('menuS2') == e.id) {
  //                     e.color = './static/img/sensation/sensation_2.png'
  //                   } else {
  //                     e.color = './static/img/sensation/sensation_1.gif'
  //                   }
  //                 } else if (e.colorType == 2) {
  //                   if (sessionStorage.getItem('menuS2') == e.id) {
  //                     e.color = './static/img/sensation/sensation_red.png'
  //                   } else {
  //                     e.color = './static/img/sensation/sensation_red1.gif'
  //                   }
  //                 }
  //               } else {
  //                 if (e.deviceStatus == 1) {
  //                   if (sessionStorage.getItem('menuS2') == e.id) {
  //                       e.color = './static/img/sensation/sensation_green.png'
  //                     } else {
  //                       e.color = './static/img/sensation/sensation_green.png'
  //                     }
  //                 } else {
  //                   if (e.lowVoltage) {
  //                     e.color = './static/img/sensation/sensation_green.png'
  //                   } else {
  //                     if (sessionStorage.getItem('menuS2') == e.id) {
  //                       e.color = './static/img/sensation/sensation_green.png'
  //                     } else {
  //                       e.color = './static/img/sensation/sensation_green.png'
  //                     }
  //                   }
  //                 }
  //               }
  //             }
  //           }else if(e.type==6) {  //灭火器
  //             if (e.connectStatus) {    //连接为true   正常
  //               if (sessionStorage.getItem('menuS2') == e.id) {
  //                       e.color = './static/img/bottle/bottle_grey.png'
  //                     } else {
  //                       e.color = './static/img/bottle/bottle_grey1.gif'
  //                     }
  //             } else {
  //               // 在线
  //               if (e.runStatus) {     //故障
  //                 if (e.colorType == 1) {
  //                   if (sessionStorage.getItem('menuS2') == e.id) {
  //                     e.color = './static/img/bottle/bottle_2.png'
  //                   } else {
  //                     e.color = './static/img/bottle/bottle_1.gif'
  //                   }
  //                 } else if (e.colorType == 2) {
  //                   if (sessionStorage.getItem('menuS2') == e.id) {
  //                     e.color = './static/img/bottle/bottle_red.png'
  //                   } else {
  //                     e.color = './static/img/bottle/bottle_red1.gif'
  //                   }
  //                 }
  //               } else {
  //                 if (e.deviceStatus == 1) {
  //                   if (sessionStorage.getItem('menuS2') == e.id) {
  //                       e.color = './static/img/bottle/bottle_green.png'
  //                     } else {
  //                       e.color = './static/img/bottle/bottle_green.png'
  //                     }
  //                 } else {
  //                   if (e.lowVoltage) {
  //                     e.color = './static/img/bottle/bottle_green.png'
  //                   } else {
  //                     if (sessionStorage.getItem('menuS2') == e.id) {
  //                       e.color = './static/img/bottle/bottle_green.png'
  //                     } else {
  //                       e.color = './static/img/bottle/bottle_green.png'
  //                     }
  //                   }
  //                 }
  //               }
  //             }
  //           }
  //       }else { //建筑
  //          if(e.colorType == 1){ //离线
  //              e.color = './static/img/lixian.gif'
  //          }else if(e.colorType == 2){ //告警
  //              e.color = './static/img/gaojing.gif'
  //          }else if(e.colorType == 3){ //预警
  //              e.color = './static/img/yujing.gif'
  //          }else{//如果状态为4是正常
  //              e.color = './static/img/zhengchang.png'
  //          }
  //       }
  //   });
  //   }
  //   if (_this.$store.state.floorList != null && _this.$store.state.floorList.length > 0) {
  //     _this.$refs.floorListUl.style.marginTop = _this.floorListIndexL1 + 'px';
  //   }
  // },
  // computed: {
  //   pointData() {
  //     return this.$store.state.pointData
  //   },
  //   point: {
  //     get() {
  //       if(!this.customerType) { //建筑
  //           this.$store.state.pointData.Info.map( e => {
  //             if(e.colorType == 1){ //离线
  //                 e.color = './static/img/lixian.gif'
  //             }else if(e.colorType == 2){ //告警
  //                 e.color = './static/img/gaojing.gif'
  //             }else if(e.colorType == 3){ //预警
  //                 e.color = './static/img/yujing.gif'
  //             }else{//如果状态为4是正常
  //                 e.color = './static/img/zhengchang.png'
  //             }
  //           });
  //       }
  //       return this.$store.state.pointData.Info
  //     },
  //     set(val) {
  //       this.$store.state.pointData.Info = val
  //     },
  //   },
  //   floorList: {
  //     get() {
  //       return this.$store.state.floorList
  //     },
  //     set(val) {
  //       this.$store.state.floorList = val
  //     },
  //   },
  //   sum: {
  //     get() {
  //       return this.$store.state.sum
  //     },
  //     set(val) {
  //       this.$store.state.sum = val
  //     },
  //   },
  //   rightList() {
  //     if(this.$store.state.rightList == false){ //四期区别首页、楼层管理
  //        this.returnTxt = '首页管理';
  //        this.customerType = false; //客户
  //     }else{
  //        this.returnTxt = '楼层管理';
  //        this.customerType = true; //建筑
  //     }
  //     return this.$store.state.rightList
  //   },
  //   imgUrl() {
  //     if(this.$store.state.pointData.PhotoUrl !=0){
  //       return uploadIp() + '/file/filePreview/' + this.$store.state.pointData.PhotoUrl
  //     }else{
  //       return ''
  //     }
  //   },
  //   deleteDisabled() {
  //     return this.$store.state.pointData.PhotoUrl != '0' ? false : true
  //   },
  //   floorListLength() {
  //     return this.$store.state.floorList.length
  //   },
  //   leftoggle() {
  //     return this.$store.state.leftoggle
  //   },
  //   navTopMsg() {
  //     return this.$store.state.navTopMsg
  //   },
  //   floorListIndexL1: {
  //     get() {
  //       return this.$store.state.floorListIndexL1;
  //     },
  //     set(val) {
  //       this.$store.state.floorListIndexL1 = val
  //     },
  //   }
  // },
  // watch: {
  //   floorList(val) {
  //     let index = val.findIndex( e => e.active == true);
  //     if (val.length == 1) {
  //         this.btnDisable1 = true;
  //         this.btnDisable2 = true;
  //     } else {
  //       if (index == 0) {
  //           this.btnDisable1 = true;
  //           this.btnDisable2 = false;
  //       } else if (index == val.length - 1) {
  //           this.btnDisable2 = true;
  //           this.btnDisable1 = false;
  //       } else {
  //           this.btnDisable1 = false;
  //           this.btnDisable2 = false;
  //       }
  //     }
  //   },
  //   btnShow(val) {
  //     if (!val) {
  //       if (window.history && window.history.pushState) {
  //           // 向历史记录中插入了当前页
  //           history.pushState(null, null, document.URL);
  //           window.addEventListener('popstate', this.goback, false);
  //       }
  //     }
  //   },
  //   'leftoggle'(val) {
  //     if (val) {
  //       this.$store.state.pointData.Info.map( e => {
  //         this.showImg1(e)
  //       })
  //     } else {
  //       this.$store.state.pointData.Info.map( e => {
  //         this.showImg(e)
  //       })
  //     }
  //   },
  //   navTopMsg(val) {
  //       if (this.isAuth('common:interface')) {
  //         let params = {
  //           buildingName: ''
  //         }
  //         ajaxFuncJson('/basicData/getBuilding',params).then(res=>{
  //           if (res.data.status ==200) {
  //             sessionStorage.setItem('leftData',JSON.stringify(res.data.data));
  //             this.$store.dispatch('getLeftDataList',res.data.data)
  //           } else {
  //             this.$message.error(res.data.msg)
  //           }
  //         });
  //       }
  //       if (sessionStorage.getItem('remark') == '0') {
  //         this.getpointMap(); //建筑
  //       } else {
  //         if(this.isAuth('common:interface')) {
  //           let params1 = {
  //             buildingId: sessionStorage.getItem('buildingId'),
  //             customerId: sessionStorage.getItem('customerId'),
  //             floorId: sessionStorage.getItem('floorid'),
  //             remark: '1'
  //           }
  //           ajaxFuncJson('/basicData/getBuildwithMonitor',params1).then(res=>{
  //             if (res.data.status ==200) {
  //               sessionStorage.setItem('pointData',JSON.stringify(res.data.data));
  //               this.$store.dispatch('getRightPoint',res.data.data);
  //             } else {
  //               this.$message.error(res.data.msg)
  //             }
  //           });
  //         }
  //       }
  //   }
  // },
  methods: {
    // changeText(e){ //文字显示...
    //   let ev = e || window.event;
    //   this.overflowText = $(ev.srcElement).outerWidth(true);
    // },
    // // 楼层列表
    // wheelList(event) {
    //   let _this = this;
    //   let ev = event || window.event;
    //   if (ev.deltaY < 0) {  // 向上滑动
    //     if (_this.sum *40 + parseInt(_this.$refs.floorListUl.style.marginTop) >= 0) {
    //       _this.$refs.floorListUl.style.marginTop = 0;
    //     } else {
    //       _this.sum += 1
    //       _this.$refs.floorListUl.style.marginTop = Math.abs(_this.sum *40) + parseInt(_this.$refs.floorListUl.style.marginTop) + 'px'
    //     }
    //   } else if (ev.deltaY > 0) {  //向下滑动
    //     if (_this.sum *40 + parseInt(_this.$refs.floorListUl.style.marginTop) <= -(_this.floorList.length -5) * 40 ) {
    //       _this.$refs.floorListUl.style.marginTop = -(_this.floorList.length - 5) * 40 + 'px';
    //       if (parseInt(_this.$refs.floorListUl.style.marginTop) > 0) {
    //         _this.$refs.floorListUl.style.marginTop = 0;
    //       }
    //     } else {
    //       _this.sum -= 1
    //       _this.$refs.floorListUl.style.marginTop = - Math.abs(_this.sum *40) + parseInt(_this.$refs.floorListUl.style.marginTop) + 'px'
    //     }
    //   }
    // },
    // showSetting(){
    //   if (this.deleteDisabled) {
    //     this.$alert('请先上传图片', '提示', {
    //       confirmButtonText: '确定',
    //     });
    //   }else {
    //     this.$alert('请点击图片区域', '提示', {
    //       confirmButtonText: '确定',
    //     });
    //   }
    // },
    // settingEvent(event){
    //   event.stopPropagation(); //此区域不受上面方法的影响
    // },
    // openDialog() {
    //   setTimeout(() => {
    //       this.dialogTipsVisible = false
    //   },6000)
    // },
    // // 删除并刷新数据
    // deleteRightPointData() {
    //   let tiptextdelete = '';
    //   if(sessionStorage.getItem('remark') == '0'){
    //     tiptextdelete = '删除平面图的同时将移除全部建筑标记，是否继续？';
    //   }else{
    //     tiptextdelete = '删除平面图的同时将移除全部监测点标记，是否继续？';
    //   }
    //   this.$confirm(tiptextdelete, '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //   }).then(() => {
    //     this.deletaState = 2;
    //     this.confirmDeleteRightPointData();
    //   }).catch(() => {
             
    //   });
    // },
    // // 删除并刷新数据
    // confirmDeleteRightPointData() {
    //   let buid,cusid,floid
    //     if (sessionStorage.getItem('remark') == '0') {   // 客户
    //       buid = '';
    //       cusid = sessionStorage.getItem('customerId');
    //       floid = '';
    //     } else if (sessionStorage.getItem('remark') == '1') {  // 建筑楼层
    //       buid = sessionStorage.getItem('buildingId');
    //       cusid = '';
    //       floid = sessionStorage.getItem('floorid')
    //     }
    //     let params = {
    //       buildingId: buid,
    //       customerId: cusid,
    //       floorId: floid,
    //     }
    //     ajaxFuncJson('/basicData/delLocationByBuildIdOrFloorId',params).then(res=>{
    //       if (res.data.status == 200) {
    //         if(this.deletaState == 2){
    //             this.tip = "删除成功！";
    //             this.dialogTipsVisible = true;
    //             let that = this;
    //             let test1 = setTimeout(function(){ //提示框
    //                 that.dialogTipsVisible = false;
    //                 clearTimeout(test1);
    //             },5000)
    //         }
    //          this.getLeftData()
    //         if (sessionStorage.getItem('remark') == '0') {
    //           this.getpointMap()          /// 刷新客户数据
    //         } else if (sessionStorage.getItem('remark') == '1') {
    //           this.getFloorMapData(buid,floid)       /// 刷新楼层数据
    //         }
    //         this.deletaState = 1;
    //       } else {
    //         this.$message.error(res.data.msg)
    //       }
    //     })
    // },
    // // 取消上传
    // cancelUpload() {
    //   let _this = this
    //   _this.dialogVisible = false;
    //   _this.$refs.fileUpload.abort(this.imgFile);
    //   _this.isConfirm = true
    // },
    // // 上传图片
    // getProgress(event, file, fileList) {
    //     this.imgFile=file;
    //     this.uploadprogress = parseInt(event.percent)
    //     if (this.uploadprogress == 100) {
    //       this.dialogVisible = false;
    //     }
    //     if (this.uploadprogress == 100) {
    //       setTimeout( () => {
    //         this.uploadprogress = 0;
    //         this.submitSuccess = true;
    //       },1000)
    //     }
    // },
    // uploadChange(file,fileList) { //上传图片执行事件
    //     let _this = this;
    //     if (!this.isConfirm) {
    //       _this.isConfirm = true
    //       return
    //     }
    //     if (_this.$store.state.pointData.PhotoUrl != '0' && _this.$store.state.pointData.PhotoUrl != 'undfined') {
    //       let tiptext = '';
    //       if(sessionStorage.getItem('remark') == '0'){
    //         tiptext = '重新上传平面图将移除全部建筑点标记，是否继续？';
    //       }else{
    //         tiptext = '重新上传平面图将移除全部监测点标记，是否继续？';
    //       }
    //       const isSubmit =  _this.$confirm(tiptext, '提示', {
    //         confirmButtonText: '确定',
    //         cancelButtonText: '取消',
    //       }).then(() => {
    //         const isJPG = file.raw.type === 'image/jpeg';
    //         const isPNG = file.raw.type === 'image/png';
    //         const isLt10M = file.raw.size / 1024 / 1024 < 10;
    //         if (!(isJPG || isPNG)) {
    //           _this.$alert('上传图片的格式只能是 JPG或PNG 格式，请重新上传!', '提示', {
    //             confirmButtonText: '确定',
    //           });
    //           _this.$refs.fileUpload.fileList = [];
    //           return false
    //         }
    //         if (!isLt10M) {
    //           _this.$alert('上传图片的大小不能超过 10MB，请重新上传!', '提示', {
    //             confirmButtonText: '确定',
    //           });
    //           _this.$refs.fileUpload.fileList = [];
    //           return false
    //         }
    //         let promise=_this.valWidthAndHeight(file.raw);
    //         promise.then(function (data) {
    //           if(data){
    //             _this.dialogVisible = true;
    //             // _this.confirmDeleteRightPointData();
    //             _this.$refs.fileUpload.submit();
    //             _this.isConfirm = false
    //           }
    //         },function (data) {

    //         })
    //       }).catch(() => {
    //         return false
    //       });
    //     } else {
    //       const isJPG1 = file.raw.type === 'image/jpeg';
    //       const isPNG1 = file.raw.type === 'image/png';
    //       const isLt10M1 = file.raw.size / 1024 / 1024 < 10;
    //       if (!(isJPG1 || isPNG1)) {
    //         _this.$alert('上传图片的格式只能是 JPG或PNG 格式，请重新上传!', '提示', {
    //           confirmButtonText: '确定',
    //         });
    //         _this.$refs.fileUpload.fileList = [];
    //         return false
    //       }
    //       if (!isLt10M1) {
    //         _this.$alert('上传图片的大小不能超过 10MB，请重新上传!', '提示', {
    //           confirmButtonText: '确定',
    //         });
    //         _this.$refs.fileUpload.fileList = [];
    //         return false
    //       }
    //       let promise=this.valWidthAndHeight(file.raw);
    //         promise.then(function (data) {
    //           if(data){
    //               _this.dialogVisible = true;
    //               _this.$refs.fileUpload.submit();
    //               _this.isConfirm = false
    //           }
    //         });
    //     }
    // },
    // valWidthAndHeight(file){ //上传图片限制
    //   let _this =this;
    //   return new Promise(function(resolve, reject) {
    //     let width = _this.validWidth;  //图片宽度
    //     let height = _this.validHeight ; //图片高度
    //     let _URL = window.URL || window.webkitURL;
    //     let image = new Image();
    //     image.src = _URL.createObjectURL(file);
    //     image.onload = function() {
    //       if(image.width<width||image.height<height){
    //         _this.isImgSize=true;
    //       }else if(image.width/image.height>3){
    //         _this.isBili=true;
    //       }
    //       let valid = image.width > width && image.height > height &&image.width/image.height<3;
    //       valid ? resolve() : reject();
    //     };
    //   }).then(
    //     () => {
    //       return file;
    //     },
    //     () => {
    //       if(_this.isImgSize){
    //         this.$alert('当前图片尺寸最小不得小于500px*500px！', '提示', {
    //           confirmButtonText: '确定',
    //           callback: action => {
    //             _this.isImgSize=false;
    //           }
    //         });
    //         this.$refs.fileUpload.uploadFiles = [];
    //       }
    //       if(_this.isBili){
    //         this.$alert('当前平面图长宽比超过3:1，请重新上传！', '提示', {
    //           confirmButtonText: '确定',
    //           callback: action => {
    //             _this.isBili=false;
    //           }
    //         });
    //         this.$refs.fileUpload.uploadFiles = [];
    //       }
    //       return Promise.reject();
    //     }
    //   );
    // },
    // successUpload(response, file, fileList) { //上传成功执行事件
    //   if (response.status == 200) {
    //     this.dialogVisible = false;
    //     let flag,cusid,floid
    //     if (sessionStorage.getItem('remark') == '0') {
    //       flag = 'customer';
    //       cusid = sessionStorage.getItem('customerId');
    //       floid = '';
    //     } else if (sessionStorage.getItem('remark') == '1') {
    //       flag = 'floor';
    //       cusid = '';
    //       floid = sessionStorage.getItem('floorid')
    //     }
    //     if(this.isAuth('basicData:insertUploadPhoto')) {
    //       let params = {
    //         flag: flag,
    //         customerId: cusid,
    //         floorId: floid,
    //         fileName: file.name,
    //         fileSize: file.size,
    //         filePath: file.response.data.savePath,
    //         buildId: sessionStorage.getItem('remark') == '0' ? '' : sessionStorage.getItem('buildingId'),
    //         customerId: sessionStorage.getItem('customerId')
    //       }
    //       ajaxFuncJson('/basicData/insertUploadPhoto',params).then(res=>{
    //         if (res.data.status == 200) {
    //           this.isSuccessImg=true;
    //           this.getLeftData()
    //           if (sessionStorage.getItem('remark') == '0') {
    //             this.getpointMap()          /// 刷新客户数据
    //           } else if (sessionStorage.getItem('remark') == '1') {
    //             this.getFloorMapData(sessionStorage.getItem('buildingId'),floid)       /// 刷新楼层数据
    //           }
    //         } else {
    //           this.$message.error(res.data.msg)
    //         }
    //       })
    //     }
    //   }
    // },
    // upFloor() { // 上一层(楼层点击)
    //   let index = this.floorList.findIndex( (e,index) => sessionStorage.getItem('floorIndex') == e.floorIndex) - 1
    //   if (index > -1) {
    //     if (index < this.floorList.length - 5) {
    //       if (index <= 4) {
    //         this.$refs.floorListUl.style.marginTop = 0;
    //         this.$store.state.floorListIndexL1 = 0;
    //         sessionStorage.setItem('floorListUlTop','0px')
    //       } else if(index > 4) {
    //         this.$store.state.floorListIndexL1 = 40 - (index-3) * 40;
    //         this.$refs.floorListUl.style.marginTop  = (40  - (index -3) * 40) + 'px';
    //         sessionStorage.setItem('floorListUlTop',this.$refs.floorListUl.style.marginTop)
    //         if (this.$refs.floorListUl.style.marginTop >= 0) {
    //           this.$store.state.floorListIndexL1 = 0;
    //           this.$refs.floorListUl.style.marginTop = 0;
    //           sessionStorage.setItem('floorListUlTop','0px')
    //         }
    //       }
    //     }
    //     this.floorActive(this.floorList[index].id,this.floorList[index].floorIndex,1)
    //   }
    //   if (index == 0) {
    //     this.btnDisable1 = true;
    //     this.btnDisable2 = false;
    //   }else if(index == -1){
    //     this.btnDisable1 = true;
    //     this.btnDisable2 = false;
    //   } else {
    //     this.btnDisable1 = false;
    //     this.btnDisable2 = false;
    //   }
    // },
    // downFloor() { // 下一层 (楼层点击)
    //   let index = this.floorList.findIndex( (e,index) => sessionStorage.getItem('floorIndex') == e.floorIndex) + 1
    //   if (index < this.floorList.length) {
    //     this.floorActive(this.floorList[index].id,this.floorList[index].floorIndex)
    //     if (index > 4) {
    //       this.$store.state.floorListIndexL1  ='-' + (index - 4) * 40;
    //       sessionStorage.setItem('floorListUlTop',this.$store.state.floorListIndexL1 + 'px')
    //     }
    //   }
    //   if (index == this.floorList.length - 1) {
    //     this.btnDisable2 = true;
    //     this.btnDisable1 = false;
    //   } else if(index == 1){
    //     this.btnDisable2 = true;
    //     this.btnDisable1 = false;
    //   }else{
    //     this.btnDisable2 = false;
    //     this.btnDisable1 = false;
    //   }
    // },
    // floorActive(id,index,i) {  // 楼层点击
    //   if(this.isAuth('common:interface')) {
    //     this.$refs.floorListUl.style.marginTop = this.$refs.floorListUl.style.marginTop;
    //     this.$store.state.floorListIndexL1 = parseInt(this.$refs.floorListUl.style.marginTop)
    //     sessionStorage.setItem('floorListUlTop',this.$refs.floorListUl.style.marginTop)
    //     let ins = this.floorList.findIndex( e => index == e.floorIndex);
    //     if (ins == 0) {
    //       this.btnDisable1 = true;
    //       this.btnDisable2 = false;
    //     } else if (ins == this.floorList.length - 1) {
    //       this.btnDisable1 = false;
    //       this.btnDisable2 = true;
    //     } else {
    //       this.btnDisable1 = false;
    //       this.btnDisable2 = false;
    //     }
    //     sessionStorage.setItem('floorid',id)      // 缓存楼层id
    //     sessionStorage.setItem('floorIndex',index)      // 缓存楼层floorIndex
    //     this.floorList.map( e => {
    //       if(e.id == id) {
    //         e.active = true;
    //         if (JSON.parse(sessionStorage.getItem('differentiate'))) {
    //           let params = {
    //             buildingId: e.buildingId,
    //             customerId: sessionStorage.getItem('customerId'),
    //             floorId: e.id
    //           }
    //           ajaxFuncJson('/basicData/getBuildwithMonitor',params).then(res=>{
    //             if (res.data.status == 200) {
    //               sessionStorage.setItem('pointData',JSON.stringify(res.data.data))
    //               this.$store.dispatch('getRightPoint',res.data.data)
    //             } else {
    //               this.$message.error(res.data.msg)
    //             }
    //           })
    //         } else {
    //           this.getFloorMapData(e.buildingId, e.id)
    //         }
    //       } else {
    //         e.active = false
    //       }
    //     })
    //     sessionStorage.setItem('floorData',JSON.stringify(this.floorList));
    //   }
    // },
    // getFloorMapData(id,ids) { // 楼层检测点点位数据
    //   if(this.isAuth('common:interface')) {
    //     let params = {
    //       buildingId: id,
    //       customerId: sessionStorage.getItem('customerId'),
    //       floorId: ids
    //     }
    //     ajaxFuncJson('/basicData/getBuildwithMonitor',params).then(res=>{
    //         if (res.data.status == 200) {
    //           sessionStorage.setItem('floor','1');
    //           sessionStorage.setItem('pointData',JSON.stringify(res.data.data))
    //           this.$store.dispatch('getRightPoint',res.data.data)
    //           this.getLeftData() // 刷新左侧数据
    //         } else {
    //           this.$message.error(res.data.msg)
    //         }
    //     });
    //   }
    // },
    // getpointMap() { // 获取客户右侧数据
    //   if (this.isAuth('common:interface') && sessionStorage.getItem('remark') == '0') {
    //     let params = {
    //       id: sessionStorage.getItem('customerId')
    //     }
    //     ajaxFuncJson('/building/showBuilding',params).then(res=>{
    //       if (res.data.status == 200) {
    //         sessionStorage.setItem('pointData',JSON.stringify(res.data.data))
    //         this.$store.dispatch('getRightPoint',res.data.data)
    //       } else {
    //         this.$message.error(res.data.msg)
    //       }
    //     });
    //   }
    // },
    // subtract() {
    //   this.value2 -= 10;
    //   this.slider(this.value2)
    // },
    // add() {
    //   this.value2 += 10;
    //   this.slider(this.value2)
    // },
    // floorManagement() {
    //   sessionStorage.setItem('btnShow',false) //区分返回
    //   this.btnShow = JSON.parse(sessionStorage.getItem('btnShow'))
    //   sessionStorage.setItem('differentiate',false); //是否可以取消选中
    //   sessionStorage.setItem('navAddShow',false); //是否有新建建筑标识
    //   this.$store.state.navAddShow = false;
    //   sessionStorage.setItem('menuS2','') //
    //   if (sessionStorage.getItem('floor') == '0') { //四期判断点击的是建筑还是
    //     this.getLeftData();
    //     this.getpointMap();
    //   } else if (sessionStorage.getItem('floor') == '1') {
    //       let params = {
    //         customerId: sessionStorage.getItem('customerId'),
    //         remark: '' + sessionStorage.getItem('remark'),
    //         buildingId: sessionStorage.getItem('buildingId'),
    //       }
    //       ajaxFuncJson('/basicData/getLeftMonitorInfo',params).then(res=>{
    //         if (res.data.status == 200) {
    //           sessionStorage.setItem('leftData',JSON.stringify(res.data.data))
    //           this.$store.dispatch('getLeftDataList',JSON.parse(sessionStorage.getItem('leftData')))
    //         } else {
    //           this.$message.error(res.data.msg)
    //         }
    //       })
    //     sessionStorage.setItem('rightList',true)    // 右侧楼层显示
    //     this.$store.state.rightList = true
    //     // 获取右侧数据//默认第一层
    //     this.floorList = JSON.parse(sessionStorage.getItem('floorData'))
    //     let floorid = '';
    //     if (this.floorList.length != '0') {
    //       this.floorList.map(e => {
    //         if (e.floorIndexs == '1') {
    //           floorid = e.id;
    //           e.active = true
    //           sessionStorage.setItem('floorid',floorid)
    //           sessionStorage.setItem('floorIndex',e.floorIndex)
    //         } else {
    //           e.active = false
    //         }
    //       })
    //       sessionStorage.setItem('floorData',JSON.stringify(this.floorList));
    //       if (this.$store.state.floorList.length > 5) {
    //           if (this.$store.state.floorList.findIndex( e => e.floorIndex == 1) > 4) {
    //             this.$store.state.floorListIndexL1 = - (this.$store.state.floorList.findIndex( e => e.floorIndex == 1) - 4) * 40;
    //           } else {
    //             this.$store.state.floorListIndexL1 = 0
    //           }
    //       } else if (this.$store.state.floorList.length == 0){

    //       } else {
    //           this.$store.state.floorListIndexL1 = 0
    //       } 
    //     } else {
    //       sessionStorage.setItem('rightList',false);  // 右侧楼层隐藏
    //       this.$store.state.rightList = false;
    //     }
    //     if(this.isAuth('common:interface')) {
    //       let params1 = {
    //         buildingId: sessionStorage.getItem('buildingId'),
    //         customerId: sessionStorage.getItem('customerId'),
    //         floorId: floorid,
    //         remark: '1'
    //       }
    //       ajaxFuncJson('/basicData/getBuildwithMonitor',params1).then(res=>{
    //           sessionStorage.setItem('pointData',JSON.stringify(res.data.data))
    //           this.$store.dispatch('getRightPoint',res.data.data)
    //       });
    //     }
    //   }
    // },
    // goback() {
    //     this.confirmGoBack()
    //     sessionStorage.setItem('menuS2','')
    // },
    // confirmGoBack() {
    //   sessionStorage.setItem('btnShow',true)
    //   this.btnShow = JSON.parse(sessionStorage.getItem('btnShow'))
    //   sessionStorage.setItem('differentiate',true);
    //   sessionStorage.setItem('navAddShow',true);
    //   this.$store.state.navAddShow = true;
    //   if (this.isAuth('common:interface')) {
    //     let params = {
    //       buildingName: ''
    //     }
    //     ajaxFuncJson('/basicData/getBuilding',params).then(res=>{ // 查询建筑列表
    //       sessionStorage.setItem('leftData',JSON.stringify(res.data.data));
    //       this.$store.dispatch('getLeftDataList',res.data.data)
    //     });
    //   }
    //   if (sessionStorage.getItem('floor') == '0') {  // 客户返回
    //     this.getpointMap()
    //   } else if (sessionStorage.getItem('floor') == '1') {
    //       // 刷新楼层和点位数据
    //       if(this.isAuth('common:interface')) {
    //           let params0 = {
    //             buildingId: sessionStorage.getItem('buildingId'),
    //           }
    //           ajaxFuncJson('/basicData/getBuildingFloor',params0).then(res=>{
    //           // 查询楼层列表
    //           if(res.data.status == 200) {
    //               this.$store.state.floorList = JSON.parse(sessionStorage.getItem('floorData'));
    //               if (res.data.data.length != '0') {        
    //                   sessionStorage.setItem('rightList',true);  // 右侧楼层显示
    //                   this.$store.state.rightList = true
    //                   this.floorListData = res.data.data
    //                   this.floorListData.map(e => {
    //                       if (e.floorIndexs == '1') {  // 默认L1层
    //                           e.active = true
    //                       } else {
    //                           e.active = false
    //                       }
    //                   })
    //                   sessionStorage.setItem('floorData',JSON.stringify(this.floorListData));
    //                   this.$store.state.floorList = JSON.parse(sessionStorage.getItem('floorData'))
    //                   res.data.data.map( e => {
    //                       if (e.floorIndexs == '1') {
    //                           this.floorid = e.id;
    //                           sessionStorage.setItem('floorid',e.id)
    //                           sessionStorage.setItem('floorIndex',e.floorIndex)
    //                       }
    //                   })
    //                   if(this.isAuth('common:interface')) {
    //                     let params1 = {
    //                       buildingId: sessionStorage.getItem('buildingId'),
    //                       customerId: sessionStorage.getItem('customerId'),
    //                       floorId: this.floorid,
    //                       remark: '1'
    //                     }
    //                     ajaxFuncJson('/basicData/getBuildwithMonitor',params1).then(res=>{
    //                         sessionStorage.setItem('pointData',JSON.stringify(res.data.data));
    //                         this.$store.dispatch('getRightPoint',res.data.data);
    //                     });
    //                   }
    //               } else {
    //                   sessionStorage.setItem('floorData',JSON.stringify(res.data.data));
    //                   this.$store.state.floorList = JSON.parse(sessionStorage.getItem('floorData'))
    //                   sessionStorage.setItem('rightList',false);  // 右侧楼层显示
    //                   this.$store.state.rightList = false;
    //                   sessionStorage.setItem('floorIndex','');
    //                   if(this.isAuth('common:interface')) {
    //                     let params2 = {
    //                       buildingId: sessionStorage.getItem('buildingId'),
    //                       customerId: sessionStorage.getItem('customerId'),
    //                       floorId: '',
    //                       remark: '1'
    //                     }
    //                     ajaxFuncJson('/basicData/getBuildwithMonitor',params2).then(res=>{
    //                         sessionStorage.setItem('pointData',JSON.stringify(res.data.data))
    //                         this.$store.dispatch('getRightPoint',res.data.data);
    //                     });
    //                   }
    //               }
    //           }
    //         });
    //       }
    //   }
    // },
    // saveConstructionManagement(a,id) { // 客户保存点位刷新点位的数据;保存
    //     if (sessionStorage.getItem('remark') == '0') {
    //         if(a == 0){//四期此判断为新增标记
    //             this.saveAdd(id);//新增标记接口
    //         }else{
    //             this.saveDle(id);//删除标记接口
    //         }
    //       //以下是建筑判断
    //     }
    //   if (this.isAuth('basicData:detectionPointLocationForCustomer')) {
    //     if (sessionStorage.getItem('remark') == '0') {
    //         if(a == 0){//四期此判断为新增标记
    //             this.saveAdd(id);//新增标记接口
    //         }else{
    //             this.saveDle(id);//删除标记接口
    //         }
    //       //以下是建筑判断
    //     } else {
    //       if (this.$store.state.pointData.Info.length == 0) {
    //         if (this.isAuth('basicData:detectionPointLocationForCustomer')) {
    //           let params = {
    //             building: {
    //               buildingId: sessionStorage.getItem('buildingId'),
    //               remark: '1',
    //               monitor: [
    //                 {
    //                   Id: '',
    //                   percentX: '',
    //                   percentY: '',
    //                   floorIndex: sessionStorage.getItem('floorIndex')
    //                 }
    //               ]
    //             },
    //           }
    //           ajaxFuncJson('/basicData/detectionPointLocationForCustomer',params).then(res=>{
    //             if (res.data.status == 200) {
    //               if(this.isAuth('common:interface')) {
    //                 let params = {
    //                   buildingId: sessionStorage.getItem('buildingId'),
    //                   customerId: sessionStorage.getItem('customerId'),
    //                   floorId: sessionStorage.getItem('floorid'),
    //                   remark: '1'
    //                 }
    //                 ajaxFuncJson('/basicData/getBuildwithMonitor',params).then(res=>{
    //                   if (res.data.status == 200) {
    //                     sessionStorage.setItem('pointData',JSON.stringify(res.data.data))
    //                     this.$store.dispatch('getRightPoint',res.data.data);
    //                   } else {
    //                     this.$message.error(res.data.msg)
    //                   }
    //                 });
    //               }
    //             } else {
    //               this.$message.error(res.data.msg)
    //             }
    //           })
    //         }
    //       } else {
    //         this.floorSetPoint = [];
    //         this.$store.state.pointData.Info.map(e => {
    //           this.floorSetPoint.push({
    //             Id: '' + e.id,
    //             percentX: '' + e.latitude,
    //             percentY: '' + e.longitude,
    //             floorIndex: sessionStorage.getItem('floorIndex')
    //           });
    //         })
    //         if (this.isAuth('basicData:detectionPointLocationForCustomer')) {
    //           let params = {
    //             building: {
    //               buildingId: sessionStorage.getItem('buildingId'),
    //               remark: '1',
    //               monitor: this.floorSetPoint
    //             },
    //           }
    //           ajaxFuncJson('/basicData/detectionPointLocationForCustomer',params).then(res=>{
    //             if (res.data.status == 200) {
    //               this.getFloorMapData(sessionStorage.getItem('buildingId'),sessionStorage.getItem('floorid'));
    //             } else {
    //               this.$message.error(res.data.msg)
    //             }
    //           });
    //         }
    //       }
    //     }
    //   }
    // },
    // //四期接口新增标记
    // saveAdd(id){
    //     // if (this.$store.state.pointData.Info.length == 0) {
    //     //     alert('标记为0')
    //     //     let params = {
    //     //       id:'',
    //     //       longitude:'',
    //     //       latitude:''
    //     //     }
    //     //     ajaxFuncJson('/building/saveBuilding',params).then(res=>{
    //     //       if (res.data.status == 200) {
    //     //         if (this.isAuth('common:interface')) {
    //     //           let params1 = {
    //     //             id: sessionStorage.getItem('customerId')
    //     //           }
    //     //           ajaxFuncJson('/building/showBuilding',params1).then(res=>{
    //     //             if (res.data.status == 200) {
    //     //               sessionStorage.setItem('pointData',JSON.stringify(res.data.data))
    //     //               this.$store.dispatch('getRightPoint',res.data.data)
    //     //               this.getLeftData()
    //     //             }
    //     //           })
    //     //         }
    //     //       } else {
    //     //         this.$message.error(res.data.msg)
    //     //       }
    //     //     })
    //     //   } else {
    //         this.setPoint = [];
    //         this.$store.state.pointData.Info.map(e => {
    //           this.setPoint.push({
    //             id: '' + e.id,
    //             latitude: '' + e.latitude,
    //             longitude: '' + e.longitude,
    //           });
    //         })
    //         let params =  this.setPoint[this.setPoint.length - 1];
    //         ajaxFuncJson('/building/saveBuilding',params).then(res=>{
    //           if (res.data.status == 200) {
    //             if (this.isAuth('common:interface')) {
    //               let params1 = {
    //                 id: sessionStorage.getItem('customerId')
    //               }
    //               ajaxFuncJson('/building/showBuilding',params1).then(res=>{
    //                 if (res.data.status == 200) {
    //                   sessionStorage.setItem('pointData',JSON.stringify(res.data.data))
    //                   this.$store.dispatch('getRightPoint',res.data.data)
    //                   this.getLeftData()
    //                 }
    //               })
    //             }
    //           } else {
    //             this.$message.error(res.data.msg)
    //           }
    //         });
    //       // }
    // },
    // //四期接口删除标记
    // saveDle(id){
    //     // if (this.$store.state.pointData.Info.length == 0) {
    //     //     alert('标记为0')
    //     //     let params = {
    //     //       id:'',
    //     //       longitude:'',
    //     //       latitude:''
    //     //     }
    //     //     ajaxFuncJson('/building/delBuilding',params).then(res=>{
    //     //       if (res.data.status == 200) {
    //     //         if (this.isAuth('common:interface')) {
    //     //           let params1 = {
    //     //             id: sessionStorage.getItem('customerId')
    //     //           }
    //     //           ajaxFuncJson('/building/showBuilding',params1).then(res=>{
    //     //             if (res.data.status == 200) {
    //     //               sessionStorage.setItem('pointData',JSON.stringify(res.data.data))
    //     //               this.$store.dispatch('getRightPoint',res.data.data)
    //     //               this.getLeftData()
    //     //             }
    //     //           })
    //     //         }
    //     //       } else {
    //     //         this.$message.error(res.data.msg)
    //     //       }
    //     //     })
    //     //   } else {
    //         this.setPoint = [];
    //         this.$store.state.pointData.Info.map(e => {
    //           this.setPoint.push({
    //             id: '' + e.id,
    //             latitude: '' + e.latitude,
    //             longitude: '' + e.longitude,
    //           });
    //         })
    //         let params =  {
    //           id:id
    //         }
    //         ajaxFuncJson('/building/delBuilding',params).then(res=>{
    //           if (res.data.status == 200) {
    //             if (this.isAuth('common:interface')) {
    //               let params1 = {
    //                 id: sessionStorage.getItem('customerId')
    //               }
    //               ajaxFuncJson('/building/showBuilding',params1).then(res=>{
    //                 if (res.data.status == 200) {
    //                   sessionStorage.setItem('pointData',JSON.stringify(res.data.data))
    //                   this.$store.dispatch('getRightPoint',res.data.data)
    //                   this.getLeftData()
    //                 }
    //               })
    //             }
    //           } else {
    //             this.$message.error(res.data.msg)
    //           }
    //         });
    //       // }
    // },
    // getLeftData() {
    //     if(sessionStorage.getItem('floor') == '0') { //点击建筑
    //     let params = {
    //           buildingName: "",
    //           target: "1"
    //         }
    //       ajaxFuncJson('/basicData/getBuilding',params).then(res=>{
    //         if (res.data.status == 200) {
    //           sessionStorage.setItem('leftData',JSON.stringify(res.data.data))
    //           this.$store.dispatch('getLeftDataList',JSON.parse(sessionStorage.getItem('leftData')))
    //         } else {
    //           this.$message.error(res.data.msg)
    //         }
    //       })
    //     } else if(sessionStorage.getItem('floor') == '1'){ //点击楼层
    //       let params = {
    //         customerId: sessionStorage.getItem('customerId'),
    //         buildingId: sessionStorage.getItem('buildingId'),
    //         remark: '' + sessionStorage.getItem('floor')
    //       }
    //       ajaxFuncJson('/basicData/getLeftMonitorInfo',params).then(res=>{
    //         if (res.data.status == 200) {
    //           sessionStorage.setItem('leftData',JSON.stringify(res.data.data))
    //           this.$store.dispatch('getLeftDataList',JSON.parse(sessionStorage.getItem('leftData')))
    //         } else {
    //           this.$message.error(res.data.msg)
    //         }
    //       })
    //     }
    // },
    // // 楼层检测带你定位
    // saveFlorPoint() {
    //   if (this.isAuth('basicData:detectionPointLocationForCustomer')) {
    //     let params = {
    //       building: {
    //         buildingId: sessionStorage.getItem('customerId'),
    //         monitor: this.floorSetPoint
    //       }
    //     }
    //     ajaxFuncJson('/basicData/detectionPointLocationForBuilding',params).then(res=>{
    //       if (res.data.status == 200) {
    //         this.getFloorMapData(sessionStorage.getItem('buildingId'),sessionStorage.getItem('floorid'))
    //       } else {
    //         this.$message.error(res.data.msg)
    //       }
    //     });
    //   }
    // },
    // formatTooltip(val) {
    //   this.value3 = parseInt((val/(100 * Math.pow(1.1,15))) * 100 * Math.pow(1.1,15)) + '%'
    //   return parseInt((val/(100 * Math.pow(1.1,15))) * 100) + '%'
    // },
    // hoverDetail(id) {
    //   this.point.map(e => {
    //     if (e.id == id) {
    //       e.povperShow = true;
    //     }
    //   });
    // },
    // outDetail(id) {
    //   this.point.map(e => {
    //     if (e.id == id) {
    //       e.povperShow = false;
    //     }
    //   });
    // },
    // // 点击坐标点事件
    // deletePoint(id) {
    //   if (this.circleUp) {
    //     this.circleUp = false;
    //     let tipTxt = '';
    //     if(sessionStorage.getItem('remark') == '0'){
    //       tipTxt = '是否移除当前建筑标记？';
    //     }else{
    //       tipTxt = '是否移除当前监测点？';
    //     }
    //     this.$confirm(tipTxt, "提示", {
    //       confirmButtonText: "确定",
    //       cancelButtonText: "取消",
    //     }).then(() => {
    //         this.point.splice(this.point.findIndex(item => item.id == id), 1);
    //         this.$store.state.pointData.Info = this.point
    //         this.circleUp = true;
    //         this.$store.state.leftMonitorInfo.map( e => {
    //           e.children.map( i => {
    //             if (id == i.id) {
    //               i.flag = true;
    //             }
    //           })
    //         })
    //         this.saveConstructionManagement('1',id)
    //       }).catch(() => {
    //         this.circleUp = true;
    //       });
    //   }
    // },
    // slider(e) {
    //   let _this = this;
    //   _this.scale = e;
    //   if(e >= 10) {
    //     _this.imgWidth = _this.$store.state.pointData.width * (_this.scale/100);
    //     _this.imgHeight= _this.$store.state.pointData.high * (_this.scale/100);
    //   }
    // },
    // slider2(e) {
    //   let _this = this;
    //   _this.scale = e;
    //   if(e >= 10) {
    //     _this.imgWidth = _this.$store.state.pointData.width * (_this.scale/100);
    //     _this.imgHeight= _this.$store.state.pointData.high * (_this.scale/100);
    //     _this.dragContainer.newPoint.left = (_this.boxwidth - _this.imgWidth) / 2;
    //     _this.dragContainer.newPoint.top = ((window.innerHeight - 127) - _this.imgHeight)/2
    //   }
    // },
    // hover(e) { //设备标记鼠标移入点标记
    //   this.$store.state.pointData.Info.map(k => {
    //     if (e== k.id) {
    //       this.$set(k,'big',true)
    //     }
    //   });
    //   let _this = this;
    //   this.hoverShow=true;
    //   _this.point.map(i => {
    //     if (e == i.id) {
    //       if(_this.$store.state.leftoggle) {
    //         _this.showPovperPath1(i);
    //       } else {
    //         _this.showPovperPath(i);
    //       }
    //       i.povperShow = true;
    //     }
    //   });
    // },
    // out(e) {// 设备标记鼠标移出目标点事件
    //   this.$store.state.pointData.Info.map(k => {
    //     if (e== k.id) {
    //       this.$set(k,'big',false)
    //     }
    //   });
    //   this.point.map(i => {
    //     if (e == i.id) {
    //       i.povperShow = false;
    //     }
    //   });
    // },
    // down(event) {
    //   // 鼠标点击按下事件
    //   let e = event || window.event;
    //   this.isDrag = false;
    //   this.circleUp = true;
    //   this.timmerHandle = setTimeout(this.setDragTrue, 200);
    // },
    // setDragTrue(event) {
    //   this.isDrag = true;
    // },
    // move(event) { }, //拖拽事件
    // up(event) {
    //   var _this = this
    //     let ev = event || window.event;
    //     if(sessionStorage.getItem('menuS2') == ''){
    //         if (sessionStorage.getItem('remark') == '0') {  // 客户级别
    //             this.tip = "请选择建筑进行标记！";
    //             this.dialogTipsVisible = true;
    //             let that = this;
    //             let test1 = setTimeout(function(){ //提示框
    //                 that.dialogTipsVisible = false;
    //                 clearTimeout(test1);
    //             },5000)
    //         } else if (sessionStorage.getItem('remark') == '1'){  // 建筑级别
    //             this.tip = "请选择设备进行标记！";
    //             this.dialogTipsVisible = true;
    //             let that = this;
    //             let test2 = setTimeout(function(){ //提示框
    //                 that.dialogTipsVisible = false;
    //                 clearTimeout(test2);
    //             },5000)
    //         }
    //     }
    //     if (!_this.isDrag) {  // 点击事件
    //       this.$store.state.leftMonitorInfo.map( e => {
    //         e.children.map( k => {
    //           if (k.id == sessionStorage.getItem('menuS2')) { //设置标记
    //             if (k.flag && this.isAuth('basicData:detectionPointLocationForCustomer')) {   // flag==true可以设置点(三期设备)
    //               let percentX = (ev.clientX - _this.setPointLeft - _this.dragContainer.newPoint.left)/this.imgWidth   // x轴点在图片中所占比例
    //               let percentY = (ev.clientY - _this.setPointTop - _this.dragContainer.newPoint.top)/this.imgHeight   // y轴点在图片中所占比例
    //               let cursPoint = []
    //               if (sessionStorage.getItem('remark') == '0') {  // 客户级别
    //                 cursPoint.push({
    //                   id: sessionStorage.getItem('menuS2'),
    //                   latitude: percentX,
    //                   longitude: percentY,
    //                 });
    //               } else if (sessionStorage.getItem('remark') == '1'){  // 建筑级别
    //                 cursPoint.push({
    //                   id: sessionStorage.getItem('menuS2'),
    //                   latitude: percentX,
    //                   longitude: percentY,
    //                 });
    //               }
    //               cursPoint.map(e => {
    //                  e.color = './static/img/green.png';
    //                 _this.$store.state.pointData.Info.push(e)
    //               });
    //               _this.$confirm('是否在此处标记监测点？', '提示', {
    //                 confirmButtonText: '确定',
    //                 cancelButtonText: '取消',
    //               }).then(() => {
    //                 _this.saveConstructionManagement()
    //               }).catch(() => {
    //                 _this.$store.state.pointData.Info.splice(_this.$store.state.pointData.Info.findIndex( e => e.id == sessionStorage.getItem('menuS2')));
    //               });
    //             }
    //             if(k.already == false && this.isAuth('building:saveBuilding')){ //四期建筑点字段（四期建筑）
    //               let percentX = (ev.clientX - _this.setPointLeft - _this.dragContainer.newPoint.left)/this.imgWidth   // x轴点在图片中所占比例
    //               let percentY = (ev.clientY - _this.setPointTop - _this.dragContainer.newPoint.top)/this.imgHeight   // y轴点在图片中所占比例
    //               let cursPoint = []
    //               if (sessionStorage.getItem('remark') == '0') {  // 客户级别
    //                 cursPoint.push({
    //                   id: sessionStorage.getItem('menuS2'),
    //                   latitude: percentX,
    //                   longitude: percentY,
    //                 });
    //               }
    //               cursPoint.map(e => {
    //                 _this.$store.state.pointData.Info.push(e)
    //               });
    //               _this.$confirm('是否在此处标记建筑点？', '提示', {
    //                 confirmButtonText: '确定',
    //                 cancelButtonText: '取消',
    //               }).then(() => {
    //                 _this.saveConstructionManagement('0','')
    //               }).catch(() => {
    //                 _this.$store.state.pointData.Info.splice(_this.$store.state.pointData.Info.findIndex( e => e.id == sessionStorage.getItem('menuS2')));
    //               });
    //             }
    //           }
    //         })
    //       })
    //     }
    // },
    // up1(event) {},  // "不做任何操作"
    // showImg(e) {
    //   if (e.remark == '0') {  // 客户点位
    //     if (window.innerWidth < 1980 && window.innerWidth >= 1366) {
    //       // 窗口宽度小于1980时
    //       let left = (e.latitude * this.scale) / 100 + this.dragContainer.newPoint.left + window.innerWidth * 0.198 + 10;
    //       let top = (e.longitude * this.scale) / 100 + this.dragContainer.newPoint.top + 118;
    //       e.imgShowPath = "left:" + left + 10 + "px; top:" + top + "px";
    //     } else {           /// 后期还是要修改坐标点
    //       let left = (e.latitude * this.scale) / 100 + this.dragContainer.newPoint.left + 366 + 10;
    //       let top = (e.longitude * this.scale) / 100 + this.dragContainer.newPoint.top + 118;
    //       e.imgShowPath = "left:" + left + "px; top:" + top + "px";
    //     }
    //   } else {
    //     if (window.innerWidth < 1980 && window.innerWidth >= 1366) {
    //       // 窗口宽度小于1980时
    //       let left = (e.latitude * this.scale) / 100 + this.dragContainer.newPoint.left + window.innerWidth * 0.198;
    //       let top = (e.longitude * this.scale) / 100 + this.dragContainer.newPoint.top + 118;
    //       e.imgShowPath = "left:" + left + "px; top:" + top + "px";
    //     } else {           /// 后期还是要修改坐标点
    //       let left = (e.latitude * this.scale) / 100 + this.dragContainer.newPoint.left + 366 + 10;
    //       let top = (e.longitude * this.scale) / 100 + this.dragContainer.newPoint.top + 118;
    //       e.imgShowPath = "left:" + left + "px; top:" + top + "px";
    //     }
    //   }  
    // },
    // // 折叠左侧导航的时候
    // showImg1(e) {
    //   if (e.remark == '0') {  // 客户点位
    //     if (window.innerWidth < 1980 && window.innerWidth >= 1366) {
    //       // 窗口宽度小于1980时
    //       let left = (e.latitude * this.scale) / 100 + this.dragContainer.newPoint.left + 10;
    //       let top = (e.longitude * this.scale) / 100 + this.dragContainer.newPoint.top + 118;
    //       e.imgShowPath = "left:" + left + "px; top:" + top + "px";
    //     } else {           /// 后期还是要修改坐标点
    //       let left = (e.latitude * this.scale) / 100 + this.dragContainer.newPoint.left + 366;
    //       let top = (e.longitude * this.scale) / 100 + this.dragContainer.newPoint.top + 118;
    //       e.imgShowPath = "left:" + left + "px; top:" + top + "px";
    //     }
    //   } else {
    //     if (window.innerWidth < 1980 && window.innerWidth >= 1366) {
    //       // 窗口宽度小于1980时
    //       let left = (e.latitude * this.scale) / 100 + this.dragContainer.newPoint.left;
    //       let top = (e.longitude * this.scale) / 100 + this.dragContainer.newPoint.top + 118;
    //       e.imgShowPath = "left:" + left + "px; top:" + top + "px";
    //     } else {           /// 后期还是要修改坐标点
    //       let left = (e.latitude * this.scale) / 100 + this.dragContainer.newPoint.left + 366 + 10;
    //       let top = (e.longitude * this.scale) / 100 + this.dragContainer.newPoint.top + 118;
    //       e.imgShowPath = "left:" + left + "px; top:" + top + "px";
    //     }
    //   }  
    // },
    // // 显示povper的位置
    // showPovperPath(e) {
    //   if (e.remark == '0') {  // 客户点位
    //     if (window.innerWidth < 1980 && window.innerWidth >= 1366) {
    //       // 窗口宽度小于1980时
    //       let left = e.latitude * this.imgWidth + this.dragContainer.newPoint.left;
    //       let top = e.longitude * this.imgHeight + this.dragContainer.newPoint.top;
    //       if (left < window.innerWidth - window.innerWidth * 0.198 + 10 + window.innerWidth * 0.0105 - 366 && top > 125 + 56) {
    //         // 定义povper右上角显示
    //         e.showDetailPath =
    //           "left:" + (left + this.setPointLeft) + "px; top:" + (top - 20 ) + "px";
    //       } else if (left < window.innerWidth - window.innerWidth * 0.198 + 10 + window.innerWidth * 0.0105 - 366 && top < 125 + 56) {
    //         // 定义povper右下角显示
    //         e.showDetailPath =
    //           "left:" + (left + this.setPointLeft) + "px; top:" + (top + 120) + "px";
    //       } else if (left > window.innerWidth - window.innerWidth * 0.198 + 10 + window.innerWidth * 0.0105 - 366 && top < 125 + 56) {
    //         // 定义povper左下角显示
    //         e.showDetailPath =
    //           "left:" + (left + this.setPointLeft - 366 + 6) + "px; top:" + (top + 120) + "px";
    //       } else if (left > window.innerWidth - window.innerWidth * 0.198 + 10 + window.innerWidth * 0.0105 - 366 && top > 125 + 56) {
    //         // 定义povper左上角显示
    //         e.showDetailPath =
    //           "left:" + (left + this.setPointLeft - 366 + 6) + "px; top:" + (top - 20) + "px";
    //       }
    //     } else {           /// 后期还是要修改坐标点
    //       let left = e.latitude * this.imgWidth + this.dragContainer.newPoint.left;
    //       let top = e.longitude * this.imgHeight + this.dragContainer.newPoint.top;
    //       if (left < window.innerWidth - 420 - 366 && top > 125 + 56) {
    //         // 定义povper右上角显示
    //         e.showDetailPath =
    //           "left:" + (left + 380 + 20 + 6) + "px; top:" + (top - 20) + "px";
    //       } else if (left < window.innerWidth - 420 - 366 && top < 125 + 56) {
    //         // 定义povper右下角显示
    //         e.showDetailPath =
    //           "left:" + (left + 380 + 20 + 6) + "px; top:" + (top + 120) + "px";
    //       } else if (left > window.innerWidth - 420 - 366 && top < 125 + 56) {
    //         // 定义povper左下角显示
    //         e.showDetailPath =
    //           "left:" + (left - 366 + 380 + 20) + "px; top:" + (top + 120) + "px";
    //       } else if (left > window.innerWidth - 420 - 366 && top > 125 + 56) {
    //         // 定义povper左上角显示
    //         e.showDetailPath =
    //           "left:" + (left - 366 + 380 + 20) + "px; top:" + (top - 20) + "px";
    //       }
    //     }
    //   } else {
    //     if (window.innerWidth < 1980 && window.innerWidth >= 1366) {
    //       // 窗口宽度小于1980时
    //       let left = e.latitude * this.imgWidth + this.dragContainer.newPoint.left;
    //       let top = e.longitude * this.imgHeight + this.dragContainer.newPoint.top;
    //       if (left < window.innerWidth - window.innerWidth * 0.198 + 10 + window.innerWidth * 0.0105 - 366 && top > 125 + 56) {
    //         // 定义povper右上角显示
    //         e.showDetailPath =
    //           "left:" + (left + this.setPointLeft ) + "px; top:" + (top - 20) + "px";
    //       } else if (left < window.innerWidth - window.innerWidth * 0.198 + 10 + window.innerWidth * 0.0105 - 366 && top < 125 + 56) {
    //         // 定义povper右下角显示
    //         e.showDetailPath =
    //           "left:" + (left + this.setPointLeft) + "px; top:" + (top + 120) + "px";
    //       } else if (left > window.innerWidth - window.innerWidth * 0.198 + 10 + window.innerWidth * 0.0105 - 366 && top < 125 + 56) {
    //         // 定义povper左下角显示
    //         e.showDetailPath =
    //           "left:" + (left + this.setPointLeft - 366 + 6) + "px; top:" + (top + 120) + "px";
    //       } else if (left > window.innerWidth - window.innerWidth * 0.198 + 10 + window.innerWidth * 0.0105 - 366 && top > 125 + 56) {
    //         // 定义povper左上角显示
    //         e.showDetailPath =
    //           "left:" + (left + this.setPointLeft - 366 + 6) + "px; top:" + (top - 20) + "px";
    //       }
    //     } else {           /// 后期还是要修改坐标点
    //       let left = e.latitude *  this.imgWidth + this.dragContainer.newPoint.left;
    //       let top = e.longitude * this.imgHeight + this.dragContainer.newPoint.top;
    //       if (left < window.innerWidth - 420 - 366 && top > 125 + 56) {
    //         // 定义povper右上角显示
    //         e.showDetailPath =
    //           "left:" + (left + 380 + 20 + 6) + "px; top:" + (top - 20) + "px";
    //       } else if (left < window.innerWidth - 420 - 366 && top < 125 + 56) {
    //         // 定义povper右下角显示
    //         e.showDetailPath =
    //           "left:" + (left + 380 + 20 + 6) + "px; top:" + (top + 120) + "px";
    //       } else if (left > window.innerWidth - 420 - 366 && top < 125 + 56) {
    //         // 定义povper左下角显示
    //         e.showDetailPath =
    //           "left:" + (left - 366 + 380 + 20) + "px; top:" + (top + 120) + "px";
    //       } else if (left > window.innerWidth - 420 - 366 && top > 125 + 56) {
    //         // 定义povper左上角显示
    //         e.showDetailPath =
    //           "left:" + (left - 366 + 380 + 20) + "px; top:" + (top - 20) + "px";
    //       }
    //     }
    //   }
    // },
    // // 折叠导航
    // showPovperPath1(e) {
    //   if (e.remark == '0') {  // 客户点位
    //     if (window.innerWidth < 1980 && window.innerWidth >= 1366) {
    //       // 窗口宽度小于1980时
    //       let left = e.latitude * this.imgWidth + this.dragContainer.newPoint.left;
    //       let top = e.longitude * this.imgHeight + this.dragContainer.newPoint.top;
    //       if (left < window.innerWidth + 10 + window.innerWidth * 0.0105 - 366 && top > 125 + 56) {
    //         // 定义povper右上角显示
    //         e.showDetailPath =
    //           "left:" + (left + 10 + window.innerWidth * 0.0105 - 6) + "px; top:" + (top - 20) + "px";
    //       } else if (left < window.innerWidth + 10 + window.innerWidth * 0.0105 - 366 && top < 125 + 56) {
    //         // 定义povper右下角显示
    //         e.showDetailPath =
    //           "left:" + (left + 10 + window.innerWidth * 0.0105 - 6) + "px; top:" + (top + 120) + "px";
    //       } else if (left > window.innerWidth + 10 + window.innerWidth * 0.0105 - 366 && top < 125 + 56) {
    //         // 定义povper左下角显示
    //         e.showDetailPath =
    //           "left:" + (left + 10 - 366 + 6) + "px; top:" + (top + 120) + "px";
    //       } else if (left > window.innerWidth + 10 + window.innerWidth * 0.0105 - 366 && top > 125 + 56) {
    //         // 定义povper左上角显示
    //         e.showDetailPath =
    //           "left:" + (left + 10 - 366 + 6) + "px; top:" + (top - 20) + "px";
    //       }
    //     } else {           /// 后期还是要修改坐标点
    //       let left = e.latitude * this.imgWidth + this.dragContainer.newPoint.left;
    //       let top = e.longitude * this.imgHeight + this.dragContainer.newPoint.top;
    //       if (left < window.innerWidth - 80 - 366 && top > 125 + 56) {
    //         // 定义povper右上角显示
    //         e.showDetailPath =
    //           "left:" + (left + 20 + 6) + "px; top:" + (top - 20) + "px";
    //       } else if (left < window.innerWidth - 80 - 366 && top < 125 + 56) {
    //         // 定义povper右下角显示
    //         e.showDetailPath =
    //           "left:" + (left + 20 + 6) + "px; top:" + (top + 120) + "px";
    //       } else if (left > window.innerWidth - 80 - 366 && top < 125 + 56) {
    //         // 定义povper左下角显示
    //         e.showDetailPath =
    //           "left:" + (left - 366 + 20) + "px; top:" + (top + 120) + "px";
    //       } else if (left > window.innerWidth - 80 - 366 && top > 125 + 56) {
    //         // 定义povper左上角显示
    //         e.showDetailPath =
    //           "left:" + (left - 366 + 20) + "px; top:" + (top - 20) + "px";
    //       }
    //     }
    //   } else {
    //     if (window.innerWidth < 1980 && window.innerWidth >= 1366) {
    //       // 窗口宽度小于1980时
    //       let left = e.latitude * this.imgWidth + this.dragContainer.newPoint.left;
    //       let top = e.longitude * this.imgHeight + this.dragContainer.newPoint.top;
    //       if (left < window.innerWidth + 10 + window.innerWidth * 0.0105 - 366 && top > 125 + 56) {
    //         // 定义povper右上角显示
    //         e.showDetailPath =
    //           "left:" + (left + 10 + window.innerWidth * 0.0105 - 10) + "px; top:" + (top - 20) + "px";
    //       } else if (left < window.innerWidth - 40 + 10 + window.innerWidth * 0.0105 - 366 && top < 125 + 56) {
    //         // 定义povper右下角显示
    //         e.showDetailPath =
    //           "left:" + (left + 10 + window.innerWidth * 0.0105 - 10) + "px; top:" + (top + 120) + "px";
    //       } else if (left > window.innerWidth - 40 + 10 + window.innerWidth * 0.0105 - 366 && top < 125 + 56) {
    //         // 定义povper左下角显示
    //         e.showDetailPath =
    //           "left:" + (left + 10 - 366 + 6) + "px; top:" + (top + 120) + "px";
    //       } else if (left > window.innerWidth - 40 + 10 + window.innerWidth * 0.0105 - 366 && top > 125 + 56) {
    //         // 定义povper左上角显示
    //         e.showDetailPath =
    //           "left:" + (left + 10 - 366 + 6) + "px; top:" + (top - 20) + "px";
    //       }
    //     } else {           /// 后期还是要修改坐标点
    //       let left = e.latitude * this.imgWidth + this.dragContainer.newPoint.left;
    //       let top = e.longitude * this.imgHeight + this.dragContainer.newPoint.top;
    //       if (left < window.innerWidth - 80 - 366 && top > 125 + 56) {
    //         // 定义povper右上角显示
    //         e.showDetailPath =
    //           "left:" + (left  + 20 + 6) + "px; top:" + (top - 20) + "px";
    //       } else if (left < window.innerWidth - 80 - 366 && top < 125 + 56) {
    //         // 定义povper右下角显示
    //         e.showDetailPath =
    //           "left:" + (left + 20 + 6) + "px; top:" + (top + 120) + "px";
    //       } else if (left > window.innerWidth - 80 - 366 && top < 125 + 56) {
    //         // 定义povper左下角显示
    //         e.showDetailPath =
    //           "left:" + (left - 366 + 20) + "px; top:" + (top + 120) + "px";
    //       } else if (left > window.innerWidth - 80 - 366 && top > 125 + 56) {
    //         // 定义povper左上角显示
    //         e.showDetailPath =
    //           "left:" + (left - 366 + 20) + "px; top:" + (top - 20) + "px";
    //       }
    //     }
    //   }
    // },
    // wheel(event) {
    //   let svgImage = document.getElementById('svgImage');
    //   let ev = event || window.event;
    //   if (ev.deltaY > 0) {
    //     // 缩小
    //     if (this.value2 > 10) {
    //       this.value2 = this.value2/1.1; // slider组件与鼠标滑轮事件wheel相关联
    //       this.dragContainer.newPoint.left += ev.offsetX - ev.offsetX/1.1;
    //       this.dragContainer.newPoint.top += ev.offsetY - ev.offsetY/1.1;
    //       this.slider(this.value2);
    //     }
    //   } else {
    //     if (this.value2 < this.maxValue) {
    //       this.value2 = this.value2 * 1.1;
    //       this.dragContainer.newPoint.left -= 0.1 * ev.offsetX;
    //       this.dragContainer.newPoint.top -= 0.1 * ev.offsetY;
    //       this.slider(this.value2);
    //     }
    //   }
    // },
    // // 鼠标在拖拽容器中按下时触发
    // DragContainerMouseDown(e) {
    //   const _this = this;
    //   // 记录鼠标点击时的初始坐标
    //   this.mousePoint = {
    //     x: e.clientX,
    //     y: e.clientY
    //   };
    //   _this.dragContainer.point = _this.dragContainer.newPoint;
    //   document.body.onmousemove = _this.DragContainerMouseMove;
    //   document.onmouseup = _this.DragContainerMouseUp;
    //   return false;
    // },
    // // 容器拖拽时触发
    // DragContainerMouseMove(e) {
    //   const _this = this;
    //   // 鼠标偏移量 = 初始坐标 - 当前坐标
    //   let dx = e.clientX - _this.mousePoint.x;
    //   let dy = e.clientY - _this.mousePoint.y;
    //   _this.dragContainer.newPoint = {
    //     left: _this.dragContainer.point.left + dx,
    //     top: _this.dragContainer.point.top + dy,
    //   }

    //   if ( _this.dragContainer.newPoint.left > _this.svgHeaderWidth/2) {
    //     if ( _this.dragContainer.newPoint.top > _this.svgHeaderHeight/2) {
    //       _this.dragContainer.newPoint = {
    //         top: _this.svgHeaderHeight/2,
    //         left: _this.svgHeaderWidth/2
    //       };
    //     } else {
    //       if ( _this.dragContainer.newPoint.top < _this.svgHeaderHeight/2 - _this.$store.state.pointData.high* _this.scale/100) {
    //         _this.dragContainer.newPoint = {
    //           top: _this.svgHeaderHeight/2 - _this.$store.state.pointData.high * _this.scale/100,
    //           left: _this.svgHeaderWidth/2
    //         };
    //       } else {
    //         _this.dragContainer.newPoint = {
    //           top: _this.dragContainer.newPoint.top,
    //           left: _this.svgHeaderWidth/2
    //         };
    //       }
    //     }

    //   } else {
    //     if ( _this.dragContainer.newPoint.left < _this.svgHeaderWidth/2 - _this.$store.state.pointData.width * _this.scale/100) {

    //       if ( _this.dragContainer.newPoint.top > _this.svgHeaderHeight/2) {
    //         _this.dragContainer.newPoint = {
    //           top: _this.svgHeaderHeight/2,
    //           left: _this.svgHeaderWidth/2 - _this.$store.state.pointData.width* _this.scale/100
    //         };
    //       } else {
    //         if ( _this.dragContainer.newPoint.top < _this.svgHeaderHeight/2 - _this.$store.state.pointData.high* _this.scale/100) {
    //           _this.dragContainer.newPoint = {
    //             top: _this.svgHeaderHeight/2 - _this.$store.state.pointData.high* _this.scale/100,
    //             left: _this.svgHeaderWidth/2 - _this.$store.state.pointData.width* _this.scale/100
    //           };
    //         } else {
    //           _this.dragContainer.newPoint = {
    //             top: _this.dragContainer.newPoint.top,
    //             left: _this.svgHeaderWidth/2 - _this.$store.state.pointData.width* _this.scale/100
    //           };
    //         }
    //       }
    //     } else {
    //       if ( _this.dragContainer.newPoint.top > _this.svgHeaderHeight/2) {
    //         _this.dragContainer.newPoint = {
    //           top: _this.svgHeaderHeight/2,
    //           left: _this.dragContainer.newPoint.left
    //         };
    //       } else {
    //         if ( _this.dragContainer.newPoint.top < _this.svgHeaderHeight/2 - _this.$store.state.pointData.high* _this.scale/100) {
    //           _this.dragContainer.newPoint = {
    //             top: _this.svgHeaderHeight/2 - _this.$store.state.pointData.high* _this.scale/100,
    //             left: _this.dragContainer.newPoint.left
    //           };
    //         } else {
    //           _this.dragContainer.newPoint = {
    //             top: _this.dragContainer.newPoint.top,
    //             left: _this.dragContainer.newPoint.left
    //           };
    //         }
    //       }
    //     }
    //   }
    //   this.point.map(e => {
    //     if(this.$store.state.leftoggle) {
    //       this.showPovperPath1(e);
    //     } else {
    //       this.showPovperPath(e);
    //     }
    //   });
    //   return false;
    // },
    // DragContainerMouseUp(e) { // 移动完成 取消onmousemove和onmouseup事件
    //   document.body.onmousemove = null;
    //   document.onmouseup = null;
    // },
    // PointMouseDown(e) {//阻止事件冒泡
    //  e.stopPropagation();
    // }
  },
  // destroyed: function () {
  //   sessionStorage.setItem('btnShow',true);
  //   sessionStorage.setItem('differentiate',true);
  //   sessionStorage.setItem('menuS','')
  //   sessionStorage.setItem('menuS2','');
  //   let _this=this;
  //   window.removeEventListener("resize",_this.windowResize);
  //   document.getElementById('bodyMain').style.overflowX = 'auto';
  //   document.getElementsByClassName('el-main')[0].style.overflow = 'auto';
  // },
};
</script>

<style lang="scss" scope>
   @import "@/assets/css/mixin.scss";

#constructionManagement {
  height: 100%;
}
#constructionManagement .el-main {
  padding: 10px 20px;
}
#constructionManagement .page {
  background: #444;
  height: calc(100% - 56px);
  position: relative;
}

#constructionManagement .image-move-wapper {
  position: absolute;
  background: #fff;
  box-shadow: rgba(255, 255, 255, 0.5);
  width: 100%;
  height: 100%;
}

#constructionManagement .image-show-box {
  width: 100%;
  height: 100%;
  cursor: move;
  overflow: hidden;
  position: relative;
}

#constructionManagement .drag-container {
  position: absolute;
  left: 0;
  top: 0;
  /*禁止元素选中*/
  -moz-user-select: none;
  /*火狐*/
  -webkit-user-select: none;
  /*webkit浏览器*/
  -ms-user-select: none;
  /*IE10*/
  -khtml-user-select: none;
  /*早期浏览器*/
  user-select: none;
}

#constructionManagement .drag-image-box {
  position: relative;
}

#constructionManagement .point {
  position: absolute;
  background: red;
  height: 30px;
  width: 30px;
  border-radius: 50%;
}
#constructionManagement .img {
  width: 20px;
  height: 20px;
  position: fixed;
}
#constructionManagement .circle {
  cursor: pointer;
}
#constructionManagement .cir {
  animation: ciranimate 500ms linear infinite;
}
#constructionManagement .svg_header {
  height:56px;
  background:#ffffff; 
  position: absolute; 
  z-index: 1
}
#constructionManagement .svg_header .svg_header_btn {
  float: right;
  margin-right: 20px;
  line-height: 56px;
  margin-top: -56px;
}
#constructionManagement .svg_header_right_btn {
  background: #ffffff;
  color: #282828;
  font-size: 14px;
}
#constructionManagement .svg_header .svg_header_title {
  float: left;
  margin-left: 20px;
  font-size: 16px;
  color: #282828;
  font-weight: bold;
  height:56px;
  line-height:56px;
}
#constructionManagement .el-slider__runway {
  margin: 26px 0;
}
#constructionManagement .el-slider__runway .el-slider__button {
  background: #409EFF;
}
#constructionManagement .disabled .el-slider__button {
  background: #999;
  border-color: #999;
}
#constructionManagement .floor_list {
  position: fixed;
  top: 46%;
  right: 40px;
  z-index: 1;
  border: 1px solid #ccc;
}
#constructionManagement .floor_list_btn {
  width: 60px !important;
  min-width: 60px !important;
  height: 30px;
  background: #ffffff;
  color: #198cff !important;
}
#constructionManagement .floor_list_btn1 {
  width: 60px !important;
  min-width: 60px !important;
  height: 30px;
  background: #ffffff;
  color: #ccc !important;
}
#constructionManagement .floor_list_btn1:hover {
  color: #ccc !important;
  border-color: #ccc !important;
}
#constructionManagement .floor_list_ul {
  overflow-y: auto;
}
#constructionManagement .floor_list_ul::-webkit-scrollbar {
  display: none;
}
#constructionManagement .floor_list_ul li {
  height: 40px;
  text-align: center;
  line-height: 40px;
  color: #282828;
  border-top: 1px solid #ccc;
  cursor: pointer;
  font-size: 14px;
  background: #ffffff;
}
#constructionManagement .floor_list_ul li:hover {
  color: #198cff;
}
#constructionManagement .floor_list_ul li.active {
  color: #ffffff;
  background: #198cff;
}
#constructionManagement .svg_header_slider {
  width: 500px;
  height:56px;
  margin: 0 auto;
}
#constructionManagement .svg_header_slider .percent {
  display: inline-block;
}
#constructionManagement .svg_header_slider i {
  margin-top: -30px;
}
#constructionManagement .el-icon-minus,.el-icon-plus {
  color: #198cff;
}
#constructionManagement .el-icon_disabled {
  color: #999 !important;
}
#constructionManagement .minus {
  position: absolute;
  width: 20px;
  top: 19px;
}
#constructionManagement .plus {
  position: absolute;
  width: 20px;
  top: 19px;
  margin-left: 10px;
}
#constructionManagement .price {
  position: absolute;
  width: 20px;
  top: 19px;
  margin-left: 30px;
  color:#198cff;
}
#constructionManagement .el-slider {
  line-height:56px;
  width:400px;
}
#constructionManagement .el-slider__runway,.el-slider__bar {
  height: 4px !important;
}
#constructionManagement .el-slider__button-wrapper {
  top: -16px;
}
#constructionManagement .upload-demo {
  display: inline-block;
  margin-right: 10px;
}
#constructionManagement .v-modal {
  opacity: .3;
}
#constructionManagement .uploadDialog .el-dialog__body{
  height: 80px;
  padding: 50px 20px 0 !important;
  .el-progress-bar__outer {
    width: 100%;
  }
  .el-progress__text {
    margin-left:12px;
  }
}
#constructionManagement .text {
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
  font-weight: 700;
  font-style: normal;
  font-size: 16px;
  color: #999999;
  position: absolute;
  width: 320px;
}
.font-icon i {
  font-weight: 700 !important;
  font-size: 16px;
}
#constructionManagement .boxItem{
        float: left;
        width: 100%;
        padding: 20px;
        @include flexible;
        @include alignItems(center);
        box-sizing: border-box;
        @include textOverflow;
        color: #282828;
        &.disabled{
          color: #666666 !important;
          & .Online,.Offline,.fault,.alarm{
              border: 1px solid #8e8e8e !important;
              background-color: #f5f5f5 !important;
          }
        }
        .boxIcon{
          position: relative;
          &>img{
            width: 80px;
            height: 80px;
            vertical-align: middle;
          }
        }
        .tipsNum{
          display: inline-block;
          position: absolute;
          left: 66px;
          top: 20px;
          padding: 0 6.5px;
          height: 20px;
          line-height: 20px;
          font-size: 12px;
          @include borderRadius(16px);
          font-weight: normal;
          font-style: normal;
          background-color: #ec1c00;
          color: #fff;
        }
        .boxText{
          margin-left: 10px;
          width: calc(100% - 80px );
          &>div{
            @include textOverflow;
            margin-bottom: 13px;
            font-size: $fontSizeOne;
          }
          &>div:nth-child(1){
            font-size: $fontSizeThree;
            line-height: 16px;
          }
          &>div:nth-child(3){
            margin-bottom: 0;
            &>span{
              display: inline-block;
              width: 45px;
              text-align: center;
              line-height: 20px;
              @include borderRadius(22px);
              box-sizing: border-box;
              margin-right: 8px;
              &.Online{
                border: 1px solid #48ff48;
                background-color: #daffda;
              }
              &.Offline{
                border: 1px solid #8e8e8e;
                background-color: #f5f5f5;
              }
              &.fault{
                border: 1px solid #fb8c00;
                background-color: #faefe1;
              }
              &.alarm{
                border: 1px solid #f55353;
                background-color: #f5dcdc;
              }
            }
          }
        }
      }
@keyframes ciranimate {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
#constructionManagement .detail {
    border: 1px solid #e0e0e0;
    width: 364px;
    height: 120px;
    background: #ffffff;
    position: fixed;
    cursor: default;
  }
#constructionManagement .floor_list .btn1 {
  border-radius: 0 !important;
  border-top: none;
  border-left: none;
  border-right: none;
}
#constructionManagement .floor_list .btn2 {
  border-radius: 0 !important;
  border-bottom: none;
  border-left: none;
  border-right: none;
}
#constructionManagement .floor_list .bor_top {
  border-top: 1px solid #ccc;
}
#constructionManagement .floor_list .bor_top:focus {
  border-color: #ccc !important;
}

#constructionManagement .topcover {
  width: 100%;
  height: 10px;
  position: fixed;
  margin-top: -10px;
  z-index: 1;
  background: #f2f2f2;
}
#constructionManagement .rightcover {
  height: 100%;
  position: relative;
  z-index: 1;
  background: #f2f2f2;
  float: right;
}
#constructionManagement .bottomcover {
  width: 100%;
  height: 10px;
  position: fixed;
  margin-top: -10px;
  z-index: 1;
  background: #f2f2f2;
  bottom: 0;
}
#constructionManagement .leftcover {
  height: 100%;
  position: fixed;
  z-index: 1;
  background: #f2f2f2;
}
#constructionManagement .el-button.is-disabled, .el-button.is-disabled:hover, .el-button.is-disabled:focus {
  color: #c9c9c9 !important;
  background: #ffffff !important;
  border-color: #f5f5f5 !important;
}
#constructionManagement .el-slider__runway {
  background-color: #c9c9c9 !important;
}
#constructionManagement .boxIconDisable {
  width: 28px;
  height: 28px;
  position: absolute;
  left: 72px;
  bottom: 15px;
  img{
    width: 100%;
    height: 100%;
    vertical-align: middle;
  }
}
/// 上传进度条样式修改
#constructionManagement .uploadDialog .el-progress-bar {
  width: 434px;
}
#constructionManagement .uploadDialog .el-dialog {
  width: 510px !important;
  height: 172px !important;
}
#constructionManagement .uploadDialog .el-dialog .el-dialog__headerbtn {
  display: none;
}
#constructionManagement .uploadDialog .el-dialog .el-dialog__header {
  padding: 20px 20px 0 20px;
}
#constructionManagement .uploadDialog .el-dialog .cancel{
  position: absolute;
  margin-top: -18px;
  color: #198cff;
  right: 20px;
  cursor: pointer;
}
/// *///
.el-main {
  z-index: 0;
}
.pointImg {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/constructionManagement/constructionManagement.vue